// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font Design System KLH/BPLH v2.1 — Plus Jakarta Sans (judul) · Inter (isi) · JetBrains Mono (data) */
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/* ! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, SF Mono, Consolas, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
:root, [data-theme]{
  color: hsl(var(--nextui-foreground));
  background-color: hsl(var(--nextui-background));
}
/* — FASE 2 · Tipografi —
     Hanya JENIS HURUF yang diatur global. Ukuran heading sengaja TIDAK diset:
     ada 48 heading polos (<h3> tanpa class) yang dipakai sebagai baris label di
     dalam popup peta, dan menaikkannya ke skala DS akan merusak popup tersebut.
     Skala tipe DS tersedia sebagai kelas .t-* di layer components. */
body {
    font-family: var(--font-body);
    font-size: var(--t-body);
    line-height: var(--lh-body);
    color: var(--ink-900);
  }
h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-display);
  }
code, kbd, samp, pre {
    font-family: var(--font-mono);
  }
/* — FASE 3 · Dasar aksesibilitas (checklist WCAG 2.1 AA design system) — */
/* Indikator fokus terlihat. Komponen NextUI memakai ring-nya sendiri (warnanya
     sudah diarahkan ke --b-500 lewat token \`focus\`); aturan di layer base ini
     hanya berlaku untuk elemen HTML biasa, karena utility NextUI menang layer. */
:focus-visible {
    outline: 3px solid var(--b-500);
    outline-offset: 2px;
    border-radius: var(--r-xs);
  }
/* CSS komponen (display:flex/grid) mengalahkan aturan UA untuk atribut hidden.
     Tanpa penegasan ini, panel yang "disembunyikan" tetap tampil. */
[hidden] {
    display: none !important;
  }
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
/* — Tautan lewati ke konten utama (wajib per checklist DS) — */
.skip {
    position: absolute;
    left: -9999px;
    top: 0;
    z-index: 100;
    display: inline-flex;
    align-items: center;
    min-height: 44px; /* checklist DS: target sentuh minimum */
    background: var(--g-600);
    color: #fff;
    padding: 10px 16px;
    border-radius: 0 0 8px 0;
    font-weight: 600;
    font-size: var(--t-sm);
  }
.skip:focus {
    left: 0;
  }
/* — Skala tipe design system, dipakai secara sengaja oleh komponen — */
.t-h2 { font-family: var(--font-display); font-size: var(--t-h2); font-weight: 700; line-height: var(--lh-snug); }
/* Panjang baris ideal prosa 60–75ch (DS §03 Tipografi) */
/* — FASE 6 · Tabel data (spesifikasi .tbl design system) —

     NextUI Table dipakai di 47 berkas, jadi header-nya diseragamkan lewat
     selektor peran alih-alih menyunting tiap pemanggilan. Hanya <th> milik
     react-aria yang cocok dengan selektor ini; MUI DataGrid memakai
     div[role="columnheader"] sehingga tidak ikut terkena — DataGrid diatur
     lewat tema MUI. !important diperlukan karena NextUI menempelkan utility
     bg-default-100 langsung pada elemen th-nya. */
th[role="columnheader"] {
    background-color: var(--g-700) !important;
    color: #ffffff !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
  }
/* Perbaikan overflow horizontal pada 390px (checklist QA design system).
     NextUI membungkus tablist dengan wadah inline-flex tanpa batas lebar,
     sehingga baris tab yang panjang melebarkan seluruh halaman: terukur
     scrollWidth 451px pada viewport 390px, dengan wadah tab selebar 429px.
     tabList-nya sendiri sudah overflow-x-scroll, jadi cukup wadahnya yang
     dibatasi; setelah itu scrollWidth turun menjadi 375px. Ini juga yang
     membuat Highcharts mengunci lebar kontainernya pada lebar yang sudah
     terlanjur melebar. */
[data-slot="base"]:has(> [data-slot="tabList"]) {
    max-width: 100%;
  }
/* ====== Target sentuh 44px (checklist layout design system) ======
     DS mewajibkan kontrol interaktif minimal 44x44px. NextUI memakai h-10
     (40px) untuk ukuran md dan h-8 (32px) untuk sm. Aplikasi ini didominasi
     sm — 183 pemakaian eksplisit, dan seluruh halaman daftar admin memakainya,
     termasuk 64 tombol ikon aksi di dalam baris tabel.

     min-height mengalahkan height, jadi tinggi dinaikkan lewat satu aturan
     tanpa menyentuh 509 pemanggilan <Button> satu per satu.

     Pengecualian DS — boleh di bawah 44px bila jarak antar-target >= 24px DAN
     ada alternatif setara yang lebih besar — tidak berlaku di sini: tombol
     edit dan hapus hanya berjarak ~8px dan tidak ada alternatif lain untuk
     aksi tersebut.

     Biaya yang disadari dan diterima: tinggi baris tabel bertambah ~10px. */
button.h-10,
  button.h-8 {
    min-height: 44px;
  }
button.h-10.w-10,
  button.h-8.w-8 {
    min-width: 44px; /* tombol ikon tetap persegi */
  }
/* Item paginasi NextUI memakai <li>/<span>, bukan <button>, sehingga tidak
     tersentuh aturan tombol di atas; ukurannya h-9 (36px). Cakupan dibatasi
     pada <nav> milik Pagination lewat atribut data-total — penanda yang khas
     dan tidak bergantung bahasa, tidak seperti aria-label yang ikut locale.
     Halaman yang sama memuat tiga elemen data-slot="item" lain yang bukan
     paginasi, dan aturan ini sengaja tidak mengenainya.
     Wadah nav-nya sudah overflow-x-scroll, jadi pelebaran tidak memicu
     overflow halaman. */
nav[data-slot="base"][data-total] [data-slot="item"],
  nav[data-slot="base"][data-total] [data-slot="prev"],
  nav[data-slot="base"][data-total] [data-slot="next"],
  nav[data-slot="base"][data-total] [data-slot="cursor"] {
    min-width: 44px;
    min-height: 44px;
  }
/* Kolom angka — padanan .tbl .num milik DS. Dipasang manual per kolom;
     pada DataGrid, kolom bertipe number sudah otomatis lewat tema MUI. */
/* Pembungkus gulir tabel. DS: tabel menggulir di dalam wadahnya pada layar
     sempit — dilarang menyembunyikan kolom kunci. */
/* Kilau skeleton — spesifikasi .skel design system. Blok
     prefers-reduced-motion di atas otomatis mematikan animasinya. */
.ds-skeleton {
    position: relative;
    overflow: hidden;
  }
.ds-skeleton::after {
    content: "";
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
    animation: ds-shimmer 1.4s infinite;
  }
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-right-2{
  right: -0.5rem;
}
.-start-4{
  inset-inline-start: -1rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-2{
  top: -0.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-\\[10\\%\\]{
  bottom: 10%;
}
.bottom-\\[5\\%\\]{
  bottom: 5%;
}
.end-1{
  inset-inline-end: 0.25rem;
}
.end-1\\.5{
  inset-inline-end: 0.375rem;
}
.end-3{
  inset-inline-end: 0.75rem;
}
.end-auto{
  inset-inline-end: auto;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-\\[10\\%\\]{
  left: 10%;
}
.left-\\[5\\%\\]{
  left: 5%;
}
.left-\\[9\\%\\]{
  left: 9%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-\\[10\\%\\]{
  right: 10%;
}
.right-\\[5\\%\\]{
  right: 5%;
}
.start-0{
  inset-inline-start: 0px;
}
.start-1\\.5{
  inset-inline-start: 0.375rem;
}
.start-2{
  inset-inline-start: 0.5rem;
}
.start-3{
  inset-inline-start: 0.75rem;
}
.start-\\[calc\\(var\\(--cursor-hit-x\\)\\*-1\\)\\]{
  inset-inline-start: calc(var(--cursor-hit-x) * -1);
}
.start-auto{
  inset-inline-start: auto;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-16{
  top: 4rem;
}
.top-2{
  top: 0.5rem;
}
.top-\\[10\\%\\]{
  top: 10%;
}
.top-\\[18\\%\\]{
  top: 18%;
}
.top-\\[3\\%\\]{
  top: 3%;
}
.top-\\[5\\%\\]{
  top: 5%;
}
.top-\\[70\\%\\]{
  top: 70%;
}
.top-\\[calc\\(100\\%_\\+_2px\\)\\]{
  top: calc(100% + 2px);
}
.top-\\[var\\(--navbar-height\\)\\]{
  top: var(--navbar-height);
}
.top-auto{
  top: auto;
}
.top-full{
  top: 100%;
}
.-z-30{
  z-index: -30;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[60\\]{
  z-index: 60;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.order-3{
  order: 3;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.-m-2{
  margin: -0.5rem;
}
.-m-2\\.5{
  margin: -0.625rem;
}
.m-0{
  margin: 0px;
}
.m-3{
  margin: 0.75rem;
}
.m-5{
  margin: 1.25rem;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-0{
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\]{
  margin-left: calc((1.25rem - 0.25rem) / 2);
  margin-right: calc((1.25rem - 0.25rem) / 2);
}
.mx-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\]{
  margin-left: calc((1.5rem - 0.75rem) / 2);
  margin-right: calc((1.5rem - 0.75rem) / 2);
}
.mx-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\]{
  margin-left: calc((1.75rem - 1.25rem) / 2);
  margin-right: calc((1.75rem - 1.25rem) / 2);
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-16{
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-7{
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.my-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\]{
  margin-top: calc((1.25rem - 0.25rem) / 2);
  margin-bottom: calc((1.25rem - 0.25rem) / 2);
}
.my-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\]{
  margin-top: calc((1.5rem - 0.75rem) / 2);
  margin-bottom: calc((1.5rem - 0.75rem) / 2);
}
.my-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\]{
  margin-top: calc((1.75rem - 1.25rem) / 2);
  margin-bottom: calc((1.75rem - 1.25rem) / 2);
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-0\\.5{
  margin-bottom: -0.125rem;
}
.-mr-2{
  margin-right: -0.5rem;
}
.-ms-2{
  margin-inline-start: -0.5rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-11{
  margin-bottom: 2.75rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[18px\\]{
  margin-bottom: 18px;
}
.mb-\\[2px\\]{
  margin-bottom: 2px;
}
.mb-px{
  margin-bottom: 1px;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.me-3{
  margin-inline-end: 0.75rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-10{
  margin-right: 2.5rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.ms-6{
  margin-inline-start: 1.5rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[5px\\]{
  margin-top: 5px;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.box-border{
  box-sizing: border-box;
}
.box-content{
  box-sizing: content-box;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.table-cell{
  display: table-cell;
}
.table-row{
  display: table-row;
}
.grid{
  display: grid;
}
.inline-grid{
  display: inline-grid;
}
.hidden{
  display: none;
}
.aspect-\\[16\\/9\\]{
  aspect-ratio: 16/9;
}
.aspect-\\[221\\/148\\]{
  aspect-ratio: 221/148;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.size-10{
  width: 2.5rem;
  height: 2.5rem;
}
.size-11{
  width: 2.75rem;
  height: 2.75rem;
}
.size-12{
  width: 3rem;
  height: 3rem;
}
.size-14{
  width: 3.5rem;
  height: 3.5rem;
}
.size-16{
  width: 4rem;
  height: 4rem;
}
.size-20{
  width: 5rem;
  height: 5rem;
}
.size-24{
  width: 6rem;
  height: 6rem;
}
.size-3{
  width: 0.75rem;
  height: 0.75rem;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.size-5{
  width: 1.25rem;
  height: 1.25rem;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.size-7{
  width: 1.75rem;
  height: 1.75rem;
}
.size-8{
  width: 2rem;
  height: 2rem;
}
.size-\\[72px\\]{
  width: 72px;
  height: 72px;
}
.size-full{
  width: 100%;
  height: 100%;
}
.\\!h-auto{
  height: auto !important;
}
.h-0{
  height: 0px;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-1\\/3{
  height: 33.333333%;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[--visual-viewport-height\\]{
  height: var(--visual-viewport-height);
}
.h-\\[100dvh\\]{
  height: 100dvh;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[24px\\]{
  height: 24px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[34px\\]{
  height: 34px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[420px\\]{
  height: 420px;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[450px\\]{
  height: 450px;
}
.h-\\[45vh\\]{
  height: 45vh;
}
.h-\\[50\\%\\]{
  height: 50%;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[530px\\]{
  height: 530px;
}
.h-\\[550px\\]{
  height: 550px;
}
.h-\\[58px\\]{
  height: 58px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[62px\\]{
  height: 62px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[90vh\\]{
  height: 90vh;
}
.h-\\[9px\\]{
  height: 9px;
}
.h-\\[calc\\(100dvh_-_var\\(--navbar-height\\)\\)\\]{
  height: calc(100dvh - var(--navbar-height));
}
.h-\\[var\\(--navbar-height\\)\\]{
  height: var(--navbar-height);
}
.h-\\[var\\(--picker-height\\)\\]{
  height: var(--picker-height);
}
.h-auto{
  height: auto;
}
.h-divider{
  height: var(--nextui-divider-weight);
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.h-topbar{
  height: 62px;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[20rem\\]{
  max-height: 20rem;
}
.max-h-\\[24rem\\]{
  max-height: 24rem;
}
.max-h-\\[28rem\\]{
  max-height: 28rem;
}
.max-h-\\[32rem\\]{
  max-height: 32rem;
}
.max-h-\\[36rem\\]{
  max-height: 36rem;
}
.max-h-\\[42rem\\]{
  max-height: 42rem;
}
.max-h-\\[48rem\\]{
  max-height: 48rem;
}
.max-h-\\[56rem\\]{
  max-height: 56rem;
}
.max-h-\\[64rem\\]{
  max-height: 64rem;
}
.max-h-\\[65vh\\]{
  max-height: 65vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[95vh\\]{
  max-height: 95vh;
}
.max-h-\\[calc\\(100\\%_-_8rem\\)\\]{
  max-height: calc(100% - 8rem);
}
.max-h-\\[none\\]{
  max-height: none;
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-10{
  min-height: 2.5rem;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-14{
  min-height: 3.5rem;
}
.min-h-16{
  min-height: 4rem;
}
.min-h-3{
  min-height: 0.75rem;
}
.min-h-3\\.5{
  min-height: 0.875rem;
}
.min-h-4{
  min-height: 1rem;
}
.min-h-5{
  min-height: 1.25rem;
}
.min-h-6{
  min-height: 1.5rem;
}
.min-h-7{
  min-height: 1.75rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-\\[100dvh\\]{
  min-height: 100dvh;
}
.min-h-\\[28px\\]{
  min-height: 28px;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[32px\\]{
  min-height: 32px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[48px\\]{
  min-height: 48px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[72px\\]{
  min-height: 72px;
}
.min-h-\\[76px\\]{
  min-height: 76px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-1\\/5{
  width: 20%;
}
.w-1\\/6{
  width: 16.666667%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-11\\/12{
  width: 91.666667%;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/4{
  width: 50%;
}
.w-2\\/5{
  width: 40%;
}
.w-2\\/6{
  width: 33.333333%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[12\\%\\]{
  width: 12%;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[15\\%\\]{
  width: 15%;
}
.w-\\[15px\\]{
  width: 15px;
}
.w-\\[16\\%\\]{
  width: 16%;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[22\\%\\]{
  width: 22%;
}
.w-\\[25\\%\\]{
  width: 25%;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[34px\\]{
  width: 34px;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[42px\\]{
  width: 42px;
}
.w-\\[44px\\]{
  width: 44px;
}
.w-\\[58px\\]{
  width: 58px;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[800px\\]{
  width: 800px;
}
.w-\\[82\\%\\]{
  width: 82%;
}
.w-\\[88px\\]{
  width: 88px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[calc\\(100\\%\\+var\\(--cursor-hit-x\\)\\*2\\)\\]{
  width: calc(100% + var(--cursor-hit-x) * 2);
}
.w-\\[calc\\(100\\%_-_16px\\)\\]{
  width: calc(100% - 16px);
}
.w-\\[calc\\(100\\%_-_theme\\(spacing\\.6\\)\\)\\]{
  width: calc(100% - 1.5rem);
}
.w-\\[calc\\(var\\(--visible-months\\)_\\*_var\\(--calendar-width\\)\\)\\]{
  width: calc(var(--visible-months) * var(--calendar-width));
}
.w-auto{
  width: auto;
}
.w-divider{
  width: var(--nextui-divider-weight);
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.w-sidebar{
  width: 264px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-12{
  min-width: 3rem;
}
.min-w-16{
  min-width: 4rem;
}
.min-w-20{
  min-width: 5rem;
}
.min-w-24{
  min-width: 6rem;
}
.min-w-3{
  min-width: 0.75rem;
}
.min-w-3\\.5{
  min-width: 0.875rem;
}
.min-w-4{
  min-width: 1rem;
}
.min-w-40{
  min-width: 10rem;
}
.min-w-5{
  min-width: 1.25rem;
}
.min-w-6{
  min-width: 1.5rem;
}
.min-w-7{
  min-width: 1.75rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-full{
  min-width: 100%;
}
.min-w-max{
  min-width: max-content;
}
.min-w-min{
  min-width: min-content;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-40{
  max-width: 10rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-\\[1024px\\]{
  max-width: 1024px;
}
.max-w-\\[1280px\\]{
  max-width: 1280px;
}
.max-w-\\[1440px\\]{
  max-width: 1440px;
}
.max-w-\\[1536px\\]{
  max-width: 1536px;
}
.max-w-\\[270px\\]{
  max-width: 270px;
}
.max-w-\\[34ch\\]{
  max-width: 34ch;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[620px\\]{
  max-width: 620px;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[70vw\\]{
  max-width: 70vw;
}
.max-w-\\[75vw\\]{
  max-width: 75vw;
}
.max-w-\\[768px\\]{
  max-width: 768px;
}
.max-w-\\[900px\\]{
  max-width: 900px;
}
.max-w-\\[none\\]{
  max-width: none;
}
.max-w-app-content{
  max-width: 1440px;
}
.max-w-fit{
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-screen-md{
  max-width: 768px;
}
.max-w-screen-sm{
  max-width: 640px;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-initial{
  flex: 0 1 auto;
}
.flex-none{
  flex: none;
}
.flex-shrink{
  flex-shrink: 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.basis-0{
  flex-basis: 0px;
}
.table-auto{
  table-layout: auto;
}
.table-fixed{
  table-layout: fixed;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-center{
  transform-origin: center;
}
.origin-left{
  transform-origin: left;
}
.origin-right{
  transform-origin: right;
}
.origin-top{
  transform-origin: top;
}
.origin-top-left{
  transform-origin: top left;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2{
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2{
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-50{
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes appearance-in{
  0%{
    opacity: 0;
    transform: translateZ(0)  scale(0.95);
  }
  60%{
    opacity: 0.75;
    backface-visibility: hidden;
    webkit-font-smoothing: antialiased;
    transform: translateZ(0) scale(1.05);
  }
  100%{
    opacity: 1;
    transform: translateZ(0) scale(1);
  }
}
.animate-\\[appearance-in_1s_infinite\\]{
  animation: appearance-in 1s infinite;
}
@keyframes drip-expand{
  0%{
    opacity: 0.2;
    transform: scale(0);
  }
  100%{
    opacity: 0;
    transform: scale(2);
  }
}
.animate-drip-expand{
  animation: drip-expand 420ms linear;
}
@keyframes indeterminate-bar{
  0%{
    transform: translateX(-50%) scaleX(0.2);
  }
  100%{
    transform: translateX(100%) scaleX(1);
  }
}
.animate-indeterminate-bar{
  animation: indeterminate-bar 1.5s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite normal none running;
}
.animate-none{
  animation: none;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
@keyframes spinner-spin{
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
.animate-spinner-ease-spin{
  animation: spinner-spin 0.8s ease infinite;
}
@keyframes spinner-spin{
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
.animate-spinner-linear-spin{
  animation: spinner-spin 0.8s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-move{
  cursor: move;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.snap-y{
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}
.snap-mandatory{
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center{
  scroll-snap-align: center;
}
.scroll-py-6{
  scroll-padding-top: 1.5rem;
  scroll-padding-bottom: 1.5rem;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-rows-1{
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.place-content-center{
  place-content: center;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.\\!gap-0{
  gap: 0px !important;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-16{
  gap: 4rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[11px\\]{
  gap: 11px;
}
.gap-\\[18px\\]{
  gap: 18px;
}
.gap-x-0{
  column-gap: 0px;
}
.gap-x-0\\.5{
  column-gap: 0.125rem;
}
.gap-x-1{
  column-gap: 0.25rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-14{
  row-gap: 3.5rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.space-x-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.125rem * var(--tw-space-x-reverse));
  margin-left: calc(0.125rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-clip{
  overflow: clip;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-x-scroll{
  overflow-x: scroll;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.break-words{
  overflow-wrap: break-word;
}
.\\!rounded-ds-md{
  border-radius: 12px !important;
}
.\\!rounded-none{
  border-radius: 0px !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[11px\\]{
  border-radius: 11px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[calc\\(theme\\(borderRadius\\.large\\)\\/1\\.5\\)\\]{
  border-radius: calc(var(--nextui-radius-large) / 1.5);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\]{
  border-radius: calc(var(--nextui-radius-medium) * 0.5);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\]{
  border-radius: calc(var(--nextui-radius-medium) * 0.6);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\]{
  border-radius: calc(var(--nextui-radius-medium) * 0.7);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\/2\\)\\]{
  border-radius: calc(var(--nextui-radius-medium) / 2);
}
.rounded-\\[calc\\(theme\\(borderRadius\\.small\\)\\/2\\)\\]{
  border-radius: calc(var(--nextui-radius-small) / 2);
}
.rounded-ds-lg{
  border-radius: 16px;
}
.rounded-ds-md{
  border-radius: 12px;
}
.rounded-ds-pill{
  border-radius: 999px;
}
.rounded-ds-sm{
  border-radius: 8px;
}
.rounded-ds-xs{
  border-radius: 4px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-large{
  border-radius: var(--nextui-radius-large);
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-medium{
  border-radius: var(--nextui-radius-medium);
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-small{
  border-radius: var(--nextui-radius-small);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.\\!rounded-e-none{
  border-start-end-radius: 0px !important;
  border-end-end-radius: 0px !important;
}
.\\!rounded-s-none{
  border-start-start-radius: 0px !important;
  border-end-start-radius: 0px !important;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-large{
  border-bottom-right-radius: var(--nextui-radius-large);
  border-bottom-left-radius: var(--nextui-radius-large);
}
.rounded-b-md{
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-b-medium{
  border-bottom-right-radius: var(--nextui-radius-medium);
  border-bottom-left-radius: var(--nextui-radius-medium);
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-small{
  border-bottom-right-radius: var(--nextui-radius-small);
  border-bottom-left-radius: var(--nextui-radius-small);
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-none{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-none{
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-large{
  border-top-left-radius: var(--nextui-radius-large);
  border-top-right-radius: var(--nextui-radius-large);
}
.rounded-t-medium{
  border-top-left-radius: var(--nextui-radius-medium);
  border-top-right-radius: var(--nextui-radius-medium);
}
.rounded-t-none{
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-small{
  border-top-left-radius: var(--nextui-radius-small);
  border-top-right-radius: var(--nextui-radius-small);
}
.rounded-bl-2xl{
  border-bottom-left-radius: 1rem;
}
.rounded-br-2xl{
  border-bottom-right-radius: 1rem;
}
.rounded-se-3xl{
  border-start-end-radius: 1.5rem;
}
.\\!border{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-1{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-3{
  border-width: 3px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-\\[2\\.5px\\]{
  border-width: 2.5px;
}
.border-\\[3\\.5px\\]{
  border-width: 3.5px;
}
.border-medium{
  border-width: var(--nextui-border-width-medium);
}
.border-small{
  border-width: var(--nextui-border-width-small);
}
.border-x-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\]{
  border-left-width: calc(1.25rem / 2);
  border-right-width: calc(1.25rem / 2);
}
.border-x-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\]{
  border-left-width: calc(1.5rem / 2);
  border-right-width: calc(1.5rem / 2);
}
.border-x-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\]{
  border-left-width: calc(1.75rem / 2);
  border-right-width: calc(1.75rem / 2);
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-y-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\]{
  border-top-width: calc(1.25rem / 2);
  border-bottom-width: calc(1.25rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\]{
  border-top-width: calc(1.5rem / 2);
  border-bottom-width: calc(1.5rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\]{
  border-top-width: calc(1.75rem / 2);
  border-bottom-width: calc(1.75rem / 2);
}
.\\!border-l-4{
  border-left-width: 4px !important;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[3px\\]{
  border-bottom-width: 3px;
}
.border-b-medium{
  border-bottom-width: var(--nextui-border-width-medium);
}
.border-l-4{
  border-left-width: 4px;
}
.border-s{
  border-inline-start-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-dotted{
  border-style: dotted;
}
.\\!border-none{
  border-style: none !important;
}
.border-none{
  border-style: none;
}
.\\!border-danger{
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity))) !important;
}
.\\!border-line{
  --tw-border-opacity: 1 !important;
  border-color: rgb(225 232 230 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#51625E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(81 98 94 / var(--tw-border-opacity, 1));
}
.border-\\[\\#52715a\\]{
  --tw-border-opacity: 1;
  border-color: rgb(82 113 90 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-background{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-border-opacity)));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/80{
  border-color: rgb(191 219 254 / 0.8);
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-danger{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.border-danger-100{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-border-opacity)));
}
.border-danger-200{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger-200) / var(--nextui-danger-200-opacity, var(--tw-border-opacity)));
}
.border-danger-line{
  --tw-border-opacity: 1;
  border-color: rgb(239 175 166 / var(--tw-border-opacity, 1));
}
.border-default{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-border-opacity)));
}
.border-default-200{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-border-opacity)));
}
.border-default-300{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-300) / var(--nextui-default-300-opacity, var(--tw-border-opacity)));
}
.border-divider{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-divider) / var(--nextui-divider-opacity, var(--tw-border-opacity)));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-foreground{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-border-opacity)));
}
.border-g-100{
  --tw-border-opacity: 1;
  border-color: rgb(222 242 241 / var(--tw-border-opacity, 1));
}
.border-g-600{
  --tw-border-opacity: 1;
  border-color: rgb(0 89 82 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-info-line{
  --tw-border-opacity: 1;
  border-color: rgb(177 208 241 / var(--tw-border-opacity, 1));
}
.border-line{
  --tw-border-opacity: 1;
  border-color: rgb(225 232 230 / var(--tw-border-opacity, 1));
}
.border-line-strong{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 207 / var(--tw-border-opacity, 1));
}
.border-line\\/80{
  border-color: rgb(225 232 230 / 0.8);
}
.border-pb-aksen{
  --tw-border-opacity: 1;
  border-color: rgb(37 102 77 / var(--tw-border-opacity, 1));
}
.border-pb-bingkai{
  --tw-border-opacity: 1;
  border-color: rgb(213 224 218 / var(--tw-border-opacity, 1));
}
.border-pb-garis{
  --tw-border-opacity: 1;
  border-color: rgb(220 227 218 / var(--tw-border-opacity, 1));
}
.border-pb-garis-menu{
  --tw-border-opacity: 1;
  border-color: rgb(71 76 70 / var(--tw-border-opacity, 1));
}
.border-pb-hutan-garis{
  --tw-border-opacity: 1;
  border-color: rgb(61 97 81 / var(--tw-border-opacity, 1));
}
.border-pb-tombol{
  --tw-border-opacity: 1;
  border-color: rgb(21 77 56 / var(--tw-border-opacity, 1));
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.border-primary-100{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary-100) / var(--nextui-primary-100-opacity, var(--tw-border-opacity)));
}
.border-primary-200{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary-200) / var(--nextui-primary-200-opacity, var(--tw-border-opacity)));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.border-secondary-100{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary-100) / var(--nextui-secondary-100-opacity, var(--tw-border-opacity)));
}
.border-secondary-200{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary-200) / var(--nextui-secondary-200-opacity, var(--tw-border-opacity)));
}
.border-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.border-success-100{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success-100) / var(--nextui-success-100-opacity, var(--tw-border-opacity)));
}
.border-success-200{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success-200) / var(--nextui-success-200-opacity, var(--tw-border-opacity)));
}
.border-success-300{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success-300) / var(--nextui-success-300-opacity, var(--tw-border-opacity)));
}
.border-success-line{
  --tw-border-opacity: 1;
  border-color: rgb(155 221 188 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.border-warning-100{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning-100) / var(--nextui-warning-100-opacity, var(--tw-border-opacity)));
}
.border-warning-200{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning-200) / var(--nextui-warning-200-opacity, var(--tw-border-opacity)));
}
.border-warning-300{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning-300) / var(--nextui-warning-300-opacity, var(--tw-border-opacity)));
}
.border-warning-500{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning-500) / var(--nextui-warning-500-opacity, var(--tw-border-opacity)));
}
.border-warning-line{
  --tw-border-opacity: 1;
  border-color: rgb(248 200 160 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/35{
  border-color: rgb(255 255 255 / 0.35);
}
.border-white\\/\\[0\\.12\\]{
  border-color: rgb(255 255 255 / 0.12);
}
.border-x-transparent{
  border-left-color: transparent;
  border-right-color: transparent;
}
.border-y-transparent{
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.\\!border-l-b-500{
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(20 125 239 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-l-danger{
  --tw-border-opacity: 1 !important;
  border-left-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity))) !important;
}
.\\!border-l-line-strong{
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(199 210 207 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-l-success{
  --tw-border-opacity: 1 !important;
  border-left-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity))) !important;
}
.border-b-current{
  border-bottom-color: currentColor;
}
.border-b-danger{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.border-b-default{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-border-opacity)));
}
.border-b-foreground{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-border-opacity)));
}
.border-b-primary{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.border-b-secondary{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.border-b-success{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.border-b-warning{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.border-b-white{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-r-transparent{
  border-right-color: transparent;
}
.border-s-danger{
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.border-s-foreground{
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-border-opacity)));
}
.border-s-primary{
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.border-s-secondary{
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.border-s-success{
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.border-s-warning{
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.border-t-g-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(0 89 82 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-danger-50{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity))) !important;
}
.\\!bg-surface{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent{
  background-color: transparent !important;
}
.bg-\\[\\#00000059\\]{
  background-color: #00000059;
}
.bg-\\[\\#00453F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 69 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#dde7e0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(221 231 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e9eee5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(233 238 229 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f7f3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 247 243 / var(--tw-bg-opacity, 1));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-b-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 125 239 / var(--tw-bg-opacity, 1));
}
.bg-b-600{
  --tw-bg-opacity: 1;
  background-color: rgb(14 102 196 / var(--tw-bg-opacity, 1));
}
.bg-background{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-bg-opacity)));
}
.bg-background\\/10{
  background-color: hsl(var(--nextui-background) / 0.1);
}
.bg-background\\/70{
  background-color: hsl(var(--nextui-background) / 0.7);
}
.bg-background\\/80{
  background-color: hsl(var(--nextui-background) / 0.8);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/90{
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/50{
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-content1{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content1) / var(--nextui-content1-opacity, var(--tw-bg-opacity)));
}
.bg-content3{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content3) / var(--nextui-content3-opacity, var(--tw-bg-opacity)));
}
.bg-current{
  background-color: currentColor;
}
.bg-danger{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.bg-danger-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-bg-opacity)));
}
.bg-danger-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.bg-danger-bg{
  --tw-bg-opacity: 1;
  background-color: rgb(251 227 224 / var(--tw-bg-opacity, 1));
}
.bg-danger\\/10{
  background-color: hsl(var(--nextui-danger) / 0.1);
}
.bg-danger\\/20{
  background-color: hsl(var(--nextui-danger) / 0.2);
}
.bg-default{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-bg-opacity)));
}
.bg-default-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.bg-default-200{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.bg-default-300\\/50{
  background-color: hsl(var(--nextui-default-300) / 0.5);
}
.bg-default-400{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-bg-opacity)));
}
.bg-default-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-50) / var(--nextui-default-50-opacity, var(--tw-bg-opacity)));
}
.bg-default-500{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-500) / var(--nextui-default-500-opacity, var(--tw-bg-opacity)));
}
.bg-default-800{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-800) / var(--nextui-default-800-opacity, var(--tw-bg-opacity)));
}
.bg-default\\/40{
  background-color: hsl(var(--nextui-default) / 0.4);
}
.bg-divider{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-divider) / var(--nextui-divider-opacity, var(--tw-bg-opacity)));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-foreground{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.bg-foreground\\/10{
  background-color: hsl(var(--nextui-foreground) / 0.1);
}
.bg-g-100{
  --tw-bg-opacity: 1;
  background-color: rgb(222 242 241 / var(--tw-bg-opacity, 1));
}
.bg-g-500{
  --tw-bg-opacity: 1;
  background-color: rgb(7 136 125 / var(--tw-bg-opacity, 1));
}
.bg-g-600{
  --tw-bg-opacity: 1;
  background-color: rgb(0 89 82 / var(--tw-bg-opacity, 1));
}
.bg-g-700{
  --tw-bg-opacity: 1;
  background-color: rgb(0 69 63 / var(--tw-bg-opacity, 1));
}
.bg-g-800{
  --tw-bg-opacity: 1;
  background-color: rgb(0 54 49 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-info-bg{
  --tw-bg-opacity: 1;
  background-color: rgb(218 232 246 / var(--tw-bg-opacity, 1));
}
.bg-ink-900\\/50{
  background-color: rgb(16 32 29 / 0.5);
}
.bg-line{
  --tw-bg-opacity: 1;
  background-color: rgb(225 232 230 / var(--tw-bg-opacity, 1));
}
.bg-line-strong{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 207 / var(--tw-bg-opacity, 1));
}
.bg-o-100{
  --tw-bg-opacity: 1;
  background-color: rgb(249 228 210 / var(--tw-bg-opacity, 1));
}
.bg-o-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 121 16 / var(--tw-bg-opacity, 1));
}
.bg-o-700{
  --tw-bg-opacity: 1;
  background-color: rgb(174 81 4 / var(--tw-bg-opacity, 1));
}
.bg-overlay\\/30{
  background-color: hsl(var(--nextui-overlay) / 0.3);
}
.bg-overlay\\/50{
  background-color: hsl(var(--nextui-overlay) / 0.5);
}
.bg-pb-garis{
  --tw-bg-opacity: 1;
  background-color: rgb(220 227 218 / var(--tw-bg-opacity, 1));
}
.bg-pb-halaman{
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 246 / var(--tw-bg-opacity, 1));
}
.bg-pb-hutan{
  --tw-bg-opacity: 1;
  background-color: rgb(21 63 50 / var(--tw-bg-opacity, 1));
}
.bg-pb-hutan-kartu{
  --tw-bg-opacity: 1;
  background-color: rgb(33 75 61 / var(--tw-bg-opacity, 1));
}
.bg-pb-kabut{
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 234 / var(--tw-bg-opacity, 1));
}
.bg-pb-kertas{
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 248 / var(--tw-bg-opacity, 1));
}
.bg-pb-motif{
  --tw-bg-opacity: 1;
  background-color: rgb(220 232 213 / var(--tw-bg-opacity, 1));
}
.bg-pb-tombol{
  --tw-bg-opacity: 1;
  background-color: rgb(21 77 56 / var(--tw-bg-opacity, 1));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.bg-primary-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-100) / var(--nextui-primary-100-opacity, var(--tw-bg-opacity)));
}
.bg-primary-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.bg-primary\\/20{
  background-color: hsl(var(--nextui-primary) / 0.2);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.bg-secondary-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-100) / var(--nextui-secondary-100-opacity, var(--tw-bg-opacity)));
}
.bg-secondary-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.bg-secondary\\/20{
  background-color: hsl(var(--nextui-secondary) / 0.2);
}
.bg-selected{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-selected) / var(--nextui-selected-opacity, var(--tw-bg-opacity)));
}
.bg-success{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.bg-success-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-100) / var(--nextui-success-100-opacity, var(--tw-bg-opacity)));
}
.bg-success-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.bg-success-bg{
  --tw-bg-opacity: 1;
  background-color: rgb(220 243 231 / var(--tw-bg-opacity, 1));
}
.bg-success\\/20{
  background-color: hsl(var(--nextui-success) / 0.2);
}
.bg-surface{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-surface-2{
  --tw-bg-opacity: 1;
  background-color: rgb(245 249 248 / var(--tw-bg-opacity, 1));
}
.bg-surface-2\\/50{
  background-color: rgb(245 249 248 / 0.5);
}
.bg-surface-3{
  --tw-bg-opacity: 1;
  background-color: rgb(235 242 240 / var(--tw-bg-opacity, 1));
}
.bg-surface-3\\/50{
  background-color: rgb(235 242 240 / 0.5);
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-warning{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.bg-warning-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-100) / var(--nextui-warning-100-opacity, var(--tw-bg-opacity)));
}
.bg-warning-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.bg-warning-bg{
  --tw-bg-opacity: 1;
  background-color: rgb(249 228 210 / var(--tw-bg-opacity, 1));
}
.bg-warning\\/20{
  background-color: hsl(var(--nextui-warning) / 0.2);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/75{
  background-color: rgb(255 255 255 / 0.75);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-opacity-25{
  --tw-bg-opacity: 0.25;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-stripe-gradient-danger{
  background-image: linear-gradient(45deg,  hsl(var(--nextui-danger-200)) 25%,  hsl(var(--nextui-danger)) 25%,  hsl(var(--nextui-danger)) 50%,  hsl(var(--nextui-danger-200)) 50%,  hsl(var(--nextui-danger-200)) 75%,  hsl(var(--nextui-danger)) 75%,  hsl(var(--nextui-danger)));
}
.bg-stripe-gradient-default{
  background-image: linear-gradient(45deg,  hsl(var(--nextui-default-200)) 25%,  hsl(var(--nextui-default-400)) 25%,  hsl(var(--nextui-default-400)) 50%,  hsl(var(--nextui-default-200)) 50%,  hsl(var(--nextui-default-200)) 75%,  hsl(var(--nextui-default-400)) 75%,  hsl(var(--nextui-default-400)));
}
.bg-stripe-gradient-primary{
  background-image: linear-gradient(45deg,  hsl(var(--nextui-primary-200)) 25%,  hsl(var(--nextui-primary)) 25%,  hsl(var(--nextui-primary)) 50%,  hsl(var(--nextui-primary-200)) 50%,  hsl(var(--nextui-primary-200)) 75%,  hsl(var(--nextui-primary)) 75%,  hsl(var(--nextui-primary)));
}
.bg-stripe-gradient-secondary{
  background-image: linear-gradient(45deg,  hsl(var(--nextui-secondary-200)) 25%,  hsl(var(--nextui-secondary)) 25%,  hsl(var(--nextui-secondary)) 50%,  hsl(var(--nextui-secondary-200)) 50%,  hsl(var(--nextui-secondary-200)) 75%,  hsl(var(--nextui-secondary)) 75%,  hsl(var(--nextui-secondary)));
}
.bg-stripe-gradient-success{
  background-image: linear-gradient(45deg,  hsl(var(--nextui-success-200)) 25%,  hsl(var(--nextui-success)) 25%,  hsl(var(--nextui-success)) 50%,  hsl(var(--nextui-success-200)) 50%,  hsl(var(--nextui-success-200)) 75%,  hsl(var(--nextui-success)) 75%,  hsl(var(--nextui-success)));
}
.bg-stripe-gradient-warning{
  background-image: linear-gradient(45deg,  hsl(var(--nextui-warning-200)) 25%,  hsl(var(--nextui-warning)) 25%,  hsl(var(--nextui-warning)) 50%,  hsl(var(--nextui-warning-200)) 50%,  hsl(var(--nextui-warning-200)) 75%,  hsl(var(--nextui-warning)) 75%,  hsl(var(--nextui-warning)));
}
.from-g-600{
  --tw-gradient-from: #005952 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 89 82 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-g-800{
  --tw-gradient-from: #003631 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 54 49 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-500{
  --tw-gradient-from: #6b7280 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 114 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #000 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-50\\%{
  --tw-gradient-via-position: 50%;
}
.to-g-700{
  --tw-gradient-to: #00453F var(--tw-gradient-to-position);
}
.to-g-700\\/95{
  --tw-gradient-to: rgb(0 69 63 / 0.95) var(--tw-gradient-to-position);
}
.to-gray-700{
  --tw-gradient-to: #374151 var(--tw-gradient-to-position);
}
.bg-stripe-size{
  background-size: 1.25rem 1.25rem;
}
.bg-clip-text{
  background-clip: text;
}
.fill-current{
  fill: currentColor;
}
.stroke-current{
  stroke: currentColor;
}
.stroke-danger{
  stroke: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, 1));
}
.stroke-default-300\\/50{
  stroke: hsl(var(--nextui-default-300) / 0.5);
}
.stroke-ink-300{
  stroke: #A6B2AE;
}
.stroke-ink-400{
  stroke: #75847F;
}
.stroke-ink-500{
  stroke: #51625E;
}
.stroke-primary{
  stroke: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, 1));
}
.stroke-success{
  stroke: hsl(var(--nextui-success) / var(--nextui-success-opacity, 1));
}
.stroke-warning{
  stroke: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, 1));
}
.stroke-2{
  stroke-width: 2;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-fill{
  object-fit: fill;
}
.object-center{
  object-position: center;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[14px_16px\\]{
  padding: 14px 16px;
}
.p-\\[18px\\]{
  padding: 18px;
}
.p-\\[22px\\]{
  padding: 22px;
}
.p-\\[2px\\]{
  padding: 2px;
}
.p-\\[3px\\]{
  padding: 3px;
}
.\\!px-1{
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.\\!px-\\[14px\\]{
  padding-left: 14px !important;
  padding-right: 14px !important;
}
.\\!py-\\[13px\\]{
  padding-top: 13px !important;
  padding-bottom: 13px !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-32{
  padding-left: 8rem;
  padding-right: 8rem;
}
.px-36{
  padding-left: 9rem;
  padding-right: 9rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[11px\\]{
  padding-left: 11px;
  padding-right: 11px;
}
.px-\\[13px\\]{
  padding-left: 13px;
  padding-right: 13px;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[22px\\]{
  padding-left: 22px;
  padding-right: 22px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-28{
  padding-top: 7rem;
  padding-bottom: 7rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[34px\\]{
  padding-top: 34px;
  padding-bottom: 34px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[72px\\]{
  padding-top: 72px;
  padding-bottom: 72px;
}
.py-\\[7px\\]{
  padding-top: 7px;
  padding-bottom: 7px;
}
.\\!pb-0{
  padding-bottom: 0px !important;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-\\[56\\.25\\%\\]{
  padding-bottom: 56.25%;
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.pe-6{
  padding-inline-end: 1.5rem;
}
.pl-0\\.5{
  padding-left: 0.125rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-\\[1px\\]{
  padding-left: 1px;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.ps-2{
  padding-inline-start: 0.5rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-topbar{
  padding-top: 62px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.\\!font-body{
  font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif !important;
}
.font-body{
  font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif;
}
.font-display{
  font-family: Plus Jakarta Sans, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif;
}
.font-mono{
  font-family: JetBrains Mono, SF Mono, Consolas, monospace;
}
.\\!text-\\[13\\.5px\\]{
  font-size: 13.5px !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-9xl{
  font-size: 8rem;
  line-height: 1;
}
.text-\\[0\\.55rem\\]{
  font-size: 0.55rem;
}
.text-\\[0\\.5rem\\]{
  font-size: 0.5rem;
}
.text-\\[0\\.6rem\\]{
  font-size: 0.6rem;
}
.text-\\[0\\.82rem\\]{
  font-size: 0.82rem;
}
.text-\\[0\\.88rem\\]{
  font-size: 0.88rem;
}
.text-\\[0\\.92rem\\]{
  font-size: 0.92rem;
}
.text-\\[0\\.9rem\\]{
  font-size: 0.9rem;
}
.text-\\[1\\.85rem\\]{
  font-size: 1.85rem;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[100\\%\\]{
  font-size: 100%;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[23px\\]{
  font-size: 23px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-large{
  font-size: var(--nextui-font-size-large);
  line-height: var(--nextui-line-height-large);
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-medium{
  font-size: var(--nextui-font-size-medium);
  line-height: var(--nextui-line-height-medium);
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-small{
  font-size: var(--nextui-font-size-small);
  line-height: var(--nextui-line-height-small);
}
.text-tiny{
  font-size: var(--nextui-font-size-tiny);
  line-height: var(--nextui-line-height-tiny);
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-extralight{
  font-weight: 200;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-10{
  line-height: 2.5rem;
}
.leading-3{
  line-height: .75rem;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[1\\.08\\]{
  line-height: 1.08;
}
.leading-\\[1\\.15\\]{
  line-height: 1.15;
}
.leading-\\[1\\.35\\]{
  line-height: 1.35;
}
.leading-\\[1\\.4\\]{
  line-height: 1.4;
}
.leading-\\[1\\.65\\]{
  line-height: 1.65;
}
.leading-\\[1\\.7\\]{
  line-height: 1.7;
}
.leading-\\[22px\\]{
  line-height: 22px;
}
.leading-\\[32px\\]{
  line-height: 32px;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.02em\\]{
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.4px\\]{
  letter-spacing: -0.4px;
}
.tracking-\\[-0\\.6px\\]{
  letter-spacing: -0.6px;
}
.tracking-\\[-0\\.8px\\]{
  letter-spacing: -0.8px;
}
.tracking-\\[-1\\.2px\\]{
  letter-spacing: -1.2px;
}
.tracking-\\[-1\\.5px\\]{
  letter-spacing: -1.5px;
}
.tracking-\\[-1px\\]{
  letter-spacing: -1px;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[1\\.5px\\]{
  letter-spacing: 1.5px;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.\\!text-danger{
  --tw-text-opacity: 1 !important;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity))) !important;
}
.\\!text-ink-900{
  --tw-text-opacity: 1 !important;
  color: rgb(16 32 29 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#00453F\\]{
  --tw-text-opacity: 1;
  color: rgb(0 69 63 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0A5A3A\\]{
  --tw-text-opacity: 1;
  color: rgb(10 90 58 / var(--tw-text-opacity, 1));
}
.text-\\[\\#172e25\\]{
  --tw-text-opacity: 1;
  color: rgb(23 46 37 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3A1B02\\]{
  --tw-text-opacity: 1;
  color: rgb(58 27 2 / var(--tw-text-opacity, 1));
}
.text-\\[\\#51625E\\]{
  --tw-text-opacity: 1;
  color: rgb(81 98 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#59665e\\]{
  --tw-text-opacity: 1;
  color: rgb(89 102 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8E2A1F\\]{
  --tw-text-opacity: 1;
  color: rgb(142 42 31 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9f9797\\]{
  --tw-text-opacity: 1;
  color: rgb(159 151 151 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-b-300{
  --tw-text-opacity: 1;
  color: rgb(119 177 238 / var(--tw-text-opacity, 1));
}
.text-b-600{
  --tw-text-opacity: 1;
  color: rgb(14 102 196 / var(--tw-text-opacity, 1));
}
.text-b-800{
  --tw-text-opacity: 1;
  color: rgb(8 62 119 / var(--tw-text-opacity, 1));
}
.text-background{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-text-opacity)));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-blue-950{
  --tw-text-opacity: 1;
  color: rgb(23 37 84 / var(--tw-text-opacity, 1));
}
.text-current{
  color: currentColor;
}
.text-danger{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.text-danger-300{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-300) / var(--nextui-danger-300-opacity, var(--tw-text-opacity)));
}
.text-danger-500{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-500) / var(--nextui-danger-500-opacity, var(--tw-text-opacity)));
}
.text-danger-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-600) / var(--nextui-danger-600-opacity, var(--tw-text-opacity)));
}
.text-danger-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.text-danger\\/80{
  color: hsl(var(--nextui-danger) / 0.8);
}
.text-default-400{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-text-opacity)));
}
.text-default-500{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-500) / var(--nextui-default-500-opacity, var(--tw-text-opacity)));
}
.text-default-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-600) / var(--nextui-default-600-opacity, var(--tw-text-opacity)));
}
.text-default-700{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-700) / var(--nextui-default-700-opacity, var(--tw-text-opacity)));
}
.text-default-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-text-opacity)));
}
.text-foreground-400{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-400) / var(--nextui-foreground-400-opacity, var(--tw-text-opacity)));
}
.text-foreground-500{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-500) / var(--nextui-foreground-500-opacity, var(--tw-text-opacity)));
}
.text-foreground-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-600) / var(--nextui-foreground-600-opacity, var(--tw-text-opacity)));
}
.text-foreground\\/50{
  color: hsl(var(--nextui-foreground) / 0.5);
}
.text-g-600{
  --tw-text-opacity: 1;
  color: rgb(0 89 82 / var(--tw-text-opacity, 1));
}
.text-g-700{
  --tw-text-opacity: 1;
  color: rgb(0 69 63 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-info-fg{
  --tw-text-opacity: 1;
  color: rgb(11 82 157 / var(--tw-text-opacity, 1));
}
.text-inherit{
  color: inherit;
}
.text-ink-300{
  --tw-text-opacity: 1;
  color: rgb(166 178 174 / var(--tw-text-opacity, 1));
}
.text-ink-400{
  --tw-text-opacity: 1;
  color: rgb(117 132 127 / var(--tw-text-opacity, 1));
}
.text-ink-500{
  --tw-text-opacity: 1;
  color: rgb(81 98 94 / var(--tw-text-opacity, 1));
}
.text-ink-700{
  --tw-text-opacity: 1;
  color: rgb(40 56 53 / var(--tw-text-opacity, 1));
}
.text-ink-900{
  --tw-text-opacity: 1;
  color: rgb(16 32 29 / var(--tw-text-opacity, 1));
}
.text-o-300{
  --tw-text-opacity: 1;
  color: rgb(247 166 100 / var(--tw-text-opacity, 1));
}
.text-o-500{
  --tw-text-opacity: 1;
  color: rgb(249 121 16 / var(--tw-text-opacity, 1));
}
.text-o-600{
  --tw-text-opacity: 1;
  color: rgb(214 99 5 / var(--tw-text-opacity, 1));
}
.text-o-700{
  --tw-text-opacity: 1;
  color: rgb(174 81 4 / var(--tw-text-opacity, 1));
}
.text-o-800{
  --tw-text-opacity: 1;
  color: rgb(134 62 3 / var(--tw-text-opacity, 1));
}
.text-pb-aksen{
  --tw-text-opacity: 1;
  color: rgb(37 102 77 / var(--tw-text-opacity, 1));
}
.text-pb-aksen\\/40{
  color: rgb(37 102 77 / 0.4);
}
.text-pb-aksen\\/50{
  color: rgb(37 102 77 / 0.5);
}
.text-pb-ink{
  --tw-text-opacity: 1;
  color: rgb(24 60 49 / var(--tw-text-opacity, 1));
}
.text-pb-jejak{
  --tw-text-opacity: 1;
  color: rgb(188 212 206 / var(--tw-text-opacity, 1));
}
.text-pb-judul{
  --tw-text-opacity: 1;
  color: rgb(27 43 38 / var(--tw-text-opacity, 1));
}
.text-pb-kaki-teks{
  --tw-text-opacity: 1;
  color: rgb(190 209 197 / var(--tw-text-opacity, 1));
}
.text-pb-limau{
  --tw-text-opacity: 1;
  color: rgb(211 230 168 / var(--tw-text-opacity, 1));
}
.text-pb-limau\\/60{
  color: rgb(211 230 168 / 0.6);
}
.text-pb-teks{
  --tw-text-opacity: 1;
  color: rgb(70 89 79 / var(--tw-text-opacity, 1));
}
.text-pb-tombol{
  --tw-text-opacity: 1;
  color: rgb(21 77 56 / var(--tw-text-opacity, 1));
}
.text-primary{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.text-primary-300{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-300) / var(--nextui-primary-300-opacity, var(--tw-text-opacity)));
}
.text-primary-500{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-500) / var(--nextui-primary-500-opacity, var(--tw-text-opacity)));
}
.text-primary-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-600) / var(--nextui-primary-600-opacity, var(--tw-text-opacity)));
}
.text-primary-800{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-800) / var(--nextui-primary-800-opacity, var(--tw-text-opacity)));
}
.text-primary-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.text-primary\\/80{
  color: hsl(var(--nextui-primary) / 0.8);
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-secondary{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.text-secondary-300{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-300) / var(--nextui-secondary-300-opacity, var(--tw-text-opacity)));
}
.text-secondary-500{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-500) / var(--nextui-secondary-500-opacity, var(--tw-text-opacity)));
}
.text-secondary-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-600) / var(--nextui-secondary-600-opacity, var(--tw-text-opacity)));
}
.text-secondary-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.text-secondary\\/80{
  color: hsl(var(--nextui-secondary) / 0.8);
}
.text-success{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.text-success-400{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-400) / var(--nextui-success-400-opacity, var(--tw-text-opacity)));
}
.text-success-500{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-500) / var(--nextui-success-500-opacity, var(--tw-text-opacity)));
}
.text-success-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-600) / var(--nextui-success-600-opacity, var(--tw-text-opacity)));
}
.text-success-700{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-700) / var(--nextui-success-700-opacity, var(--tw-text-opacity)));
}
.text-success-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.text-success\\/80{
  color: hsl(var(--nextui-success) / 0.8);
}
.text-transparent{
  color: transparent;
}
.text-warning{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.text-warning-400{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-400) / var(--nextui-warning-400-opacity, var(--tw-text-opacity)));
}
.text-warning-500{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-500) / var(--nextui-warning-500-opacity, var(--tw-text-opacity)));
}
.text-warning-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-600) / var(--nextui-warning-600-opacity, var(--tw-text-opacity)));
}
.text-warning-700{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-700) / var(--nextui-warning-700-opacity, var(--tw-text-opacity)));
}
.text-warning-800{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-800) / var(--nextui-warning-800-opacity, var(--tw-text-opacity)));
}
.text-warning-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.text-warning\\/80{
  color: hsl(var(--nextui-warning) / 0.8);
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/35{
  color: rgb(255 255 255 / 0.35);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-yellow-300{
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.no-underline{
  text-decoration-line: none;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subpixel-antialiased{
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-\\[0\\.0001\\]{
  opacity: 0.0001;
}
.opacity-\\[value\\]{
  opacity: value;
}
.opacity-disabled{
  opacity: var(--nextui-disabled-opacity);
}
.\\!shadow-ds-2{
  --tw-shadow: 0 2px 6px rgba(0,54,49,.08),0 6px 16px rgba(0,54,49,.07) !important;
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color), 0 6px 16px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.\\!shadow-none{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_var\\(--g-100\\)\\]{
  --tw-shadow: 0 0 0 4px var(--g-100);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(0\\2c 89\\2c 82\\2c 0\\.14\\)\\]{
  --tw-shadow: 0 12px 32px rgba(0,89,82,0.14);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_20px_20px_0px_rgb\\(0_0_0\\/0\\.05\\)\\]{
  --tw-shadow: 0px 20px 20px 0px rgb(0 0 0/0.05);
  --tw-shadow-colored: 0px 20px 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-ds-1{
  --tw-shadow: 0 1px 2px rgba(0,54,49,.06),0 1px 3px rgba(0,54,49,.05);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color), 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-ds-3{
  --tw-shadow: 0 12px 32px rgba(0,54,49,.12);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-large{
  --tw-shadow: var(--nextui-box-shadow-large);
  --tw-shadow-colored: var(--nextui-box-shadow-large);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-medium{
  --tw-shadow: var(--nextui-box-shadow-medium);
  --tw-shadow-colored: var(--nextui-box-shadow-medium);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-small{
  --tw-shadow: var(--nextui-box-shadow-small);
  --tw-shadow-colored: var(--nextui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/5{
  --tw-shadow-color: rgb(0 0 0 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-danger\\/40{
  --tw-shadow-color: hsl(var(--nextui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-default\\/50{
  --tw-shadow-color: hsl(var(--nextui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-foreground\\/40{
  --tw-shadow-color: hsl(var(--nextui-foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/40{
  --tw-shadow-color: hsl(var(--nextui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-secondary\\/40{
  --tw-shadow-color: hsl(var(--nextui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-success\\/40{
  --tw-shadow-color: hsl(var(--nextui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-warning\\/40{
  --tw-shadow-color: hsl(var(--nextui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.\\!outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-background{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-ring-opacity)));
}
.ring-danger{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-ring-opacity)));
}
.ring-default{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-ring-opacity)));
}
.ring-focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-focus) / var(--nextui-focus-opacity, var(--tw-ring-opacity)));
}
.ring-primary{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-ring-opacity)));
}
.ring-secondary{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-ring-opacity)));
}
.ring-success{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-ring-opacity)));
}
.ring-transparent{
  --tw-ring-color: transparent;
}
.ring-warning{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-ring-opacity)));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--nextui-background) / var(--nextui-background-opacity, 1));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-lg{
  --tw-blur: blur(16px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-xl{
  --tw-drop-shadow: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.saturate-150{
  --tw-saturate: saturate(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg{
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-opacity-disabled{
  --tw-backdrop-opacity: opacity(var(--nextui-disabled-opacity));
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-150{
  --tw-backdrop-saturate: saturate(1.5);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition-none{
  transition-property: none !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[color\\2c opacity\\]{
  transition-property: color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[opacity\\2c transform\\]{
  transition-property: opacity,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[transform\\2c background-color\\2c color\\]{
  transition-property: transform,background-color,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[transform\\2c color\\2c left\\2c opacity\\]{
  transition-property: transform,color,left,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[transform\\2c visibility\\]{
  transition-property: transform,visibility;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-none{
  transition-property: none;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.\\!duration-100{
  transition-duration: 100ms !important;
}
.\\!duration-150{
  transition-duration: 150ms !important;
}
.\\!duration-200{
  transition-duration: 200ms !important;
}
.\\!duration-250{
  transition-duration: 250ms !important;
}
.\\!duration-300{
  transition-duration: 300ms !important;
}
.\\!duration-500{
  transition-duration: 500ms !important;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.\\!ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
.\\!ease-soft-spring{
  transition-timing-function: cubic-bezier(0.155, 1.105, 0.295, 1.12) !important;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-auto{
  will-change: auto;
}
.will-change-transform{
  will-change: transform;
}
:root,.light,[data-theme="light"]{
  color-scheme: light;
  --nextui-background: 165 18.18% 95.69%;
  --nextui-foreground: 168.75 33.33% 9.41%;
  --nextui-divider: 162.86 13.21% 89.61%;
  --nextui-focus: 211.23000000000002 87.25% 50.78%;
  --nextui-overlay: 0 0% 0%;
  --nextui-content1: 0 0% 100%;
  --nextui-content2: 165 25% 96.86%;
  --nextui-content3: 162.86 21.21% 93.53%;
  --nextui-content4: 162.86 13.21% 89.61%;
  --nextui-default-50: 165 25% 96.86%;
  --nextui-default-100: 162.86 21.21% 93.53%;
  --nextui-default-200: 162.86 13.21% 89.61%;
  --nextui-default-300: 163.64 10.89% 80.2%;
  --nextui-default-400: 160 7.23% 67.45%;
  --nextui-default-500: 160 6.02% 48.82%;
  --nextui-default-600: 165.88 9.5% 35.1%;
  --nextui-default-700: 168.75 16.67% 18.82%;
  --nextui-default-800: 168 21.13% 13.92%;
  --nextui-default-900: 168.75 33.33% 9.41%;
  --nextui-default-foreground: 168.75 33.33% 9.41%;
  --nextui-default: 165 18.18% 95.69%;
  --nextui-primary-50: 180 33.33% 95.88%;
  --nextui-primary-100: 177 43.48% 90.98%;
  --nextui-primary-200: 175.20000000000005 54.35% 81.96%;
  --nextui-primary-300: 175.10000000000002 59.76% 67.84%;
  --nextui-primary-400: 175.09000000000003 69.8% 48.04%;
  --nextui-primary-500: 174.88 90.21% 28.04%;
  --nextui-primary-600: 175.27999999999997 100% 17.45%;
  --nextui-primary-700: 174.77999999999997 100% 13.53%;
  --nextui-primary-800: 174.44000000000005 100% 10.59%;
  --nextui-primary-900: 175.26 100% 7.45%;
  --nextui-primary-foreground: 0 0% 100%;
  --nextui-primary: 175.27999999999997 100% 17.45%;
  --nextui-secondary-50: 207.26999999999998 52.38% 95.88%;
  --nextui-secondary-100: 210 60.87% 90.98%;
  --nextui-secondary-200: 210.94000000000005 69.57% 81.96%;
  --nextui-secondary-300: 210.76 77.78% 70%;
  --nextui-secondary-400: 211.06999999999994 82.35% 60%;
  --nextui-secondary-500: 211.23000000000002 87.25% 50.78%;
  --nextui-secondary-600: 210.99 86.67% 41.18%;
  --nextui-secondary-700: 210.81999999999994 86.9% 32.94%;
  --nextui-secondary-800: 210.80999999999995 87.4% 24.9%;
  --nextui-secondary-900: 210.75 86.96% 18.04%;
  --nextui-secondary-foreground: 0 0% 100%;
  --nextui-secondary: 210.99 86.67% 41.18%;
  --nextui-success-50: 150 50% 96.08%;
  --nextui-success-100: 148.7 48.94% 90.78%;
  --nextui-success-200: 150 49.25% 73.73%;
  --nextui-success-300: 151.3 45.1% 60%;
  --nextui-success-400: 151.89 50.23% 43.33%;
  --nextui-success-500: 155.55999999999995 79.41% 26.67%;
  --nextui-success-600: 155.60000000000002 80.53% 22.16%;
  --nextui-success-700: 155.34000000000003 80.22% 17.84%;
  --nextui-success-800: 156 79.71% 13.53%;
  --nextui-success-900: 156.31999999999994 82.61% 9.02%;
  --nextui-success-foreground: 0 0% 100%;
  --nextui-success: 155.55999999999995 79.41% 26.67%;
  --nextui-warning-50: 25.70999999999998 70% 96.08%;
  --nextui-warning-100: 27.689999999999998 76.47% 90%;
  --nextui-warning-200: 27.269999999999982 86.27% 80%;
  --nextui-warning-300: 26.939999999999998 90.18% 68.04%;
  --nextui-warning-400: 26.910000000000025 95.1% 60%;
  --nextui-warning-500: 27.04000000000002 95.1% 51.96%;
  --nextui-warning-600: 26.99000000000001 95.43% 42.94%;
  --nextui-warning-700: 27.180000000000007 95.51% 34.9%;
  --nextui-warning-800: 27.019999999999982 95.62% 26.86%;
  --nextui-warning-900: 26.879999999999995 94.12% 20%;
  --nextui-warning-foreground: 0 0% 100%;
  --nextui-warning: 27.180000000000007 95.51% 34.9%;
  --nextui-danger-50: 4.6200000000000045 76.47% 96.67%;
  --nextui-danger-100: 6.670000000000016 77.14% 93.14%;
  --nextui-danger-200: 7.399999999999977 69.52% 79.41%;
  --nextui-danger-300: 6.350000000000023 64.2% 68.24%;
  --nextui-danger-400: 6.410000000000025 58.74% 56.27%;
  --nextui-danger-500: 6.0400000000000205 63.4% 46.08%;
  --nextui-danger-600: 5.6299999999999955 64.65% 38.82%;
  --nextui-danger-700: 5.660000000000025 66.25% 31.37%;
  --nextui-danger-800: 5.850000000000023 67.21% 23.92%;
  --nextui-danger-900: 5.259999999999991 67.06% 16.67%;
  --nextui-danger-foreground: 0 0% 100%;
  --nextui-danger: 6.0400000000000205 63.4% 46.08%;
  --nextui-selected: 177 43.48% 90.98%;
  --nextui-selected-foreground: 174.77999999999997 100% 13.53%;
  --nextui-divider-weight: 1px;
  --nextui-disabled-opacity: .5;
  --nextui-font-size-tiny: 0.75rem;
  --nextui-font-size-small: 0.875rem;
  --nextui-font-size-medium: 1rem;
  --nextui-font-size-large: 1.125rem;
  --nextui-line-height-tiny: 1rem;
  --nextui-line-height-small: 1.25rem;
  --nextui-line-height-medium: 1.5rem;
  --nextui-line-height-large: 1.75rem;
  --nextui-radius-small: 8px;
  --nextui-radius-medium: 12px;
  --nextui-radius-large: 16px;
  --nextui-border-width-small: 1px;
  --nextui-border-width-medium: 1.5px;
  --nextui-border-width-large: 2px;
  --nextui-box-shadow-small: 0 1px 2px rgba(0,54,49,.06),0 1px 3px rgba(0,54,49,.05);
  --nextui-box-shadow-medium: 0 2px 6px rgba(0,54,49,.08),0 6px 16px rgba(0,54,49,.07);
  --nextui-box-shadow-large: 0 12px 32px rgba(0,54,49,.12);
  --nextui-hover-opacity: .8;
}
.dark,[data-theme="dark"]{
  color-scheme: dark;
  --nextui-background: 0 0% 0%;
  --nextui-foreground-50: 240 5.88% 10%;
  --nextui-foreground-100: 240 3.7% 15.88%;
  --nextui-foreground-200: 240 5.26% 26.08%;
  --nextui-foreground-300: 240 5.2% 33.92%;
  --nextui-foreground-400: 240 3.83% 46.08%;
  --nextui-foreground-500: 240 5.03% 64.9%;
  --nextui-foreground-600: 240 4.88% 83.92%;
  --nextui-foreground-700: 240 5.88% 90%;
  --nextui-foreground-800: 240 4.76% 95.88%;
  --nextui-foreground-900: 0 0% 98.04%;
  --nextui-foreground: 210 5.56% 92.94%;
  --nextui-focus: 212.01999999999998 100% 46.67%;
  --nextui-overlay: 0 0% 0%;
  --nextui-divider: 0 0% 100%;
  --nextui-divider-opacity: 0.15;
  --nextui-content1: 240 5.88% 10%;
  --nextui-content1-foreground: 0 0% 98.04%;
  --nextui-content2: 240 3.7% 15.88%;
  --nextui-content2-foreground: 240 4.76% 95.88%;
  --nextui-content3: 240 5.26% 26.08%;
  --nextui-content3-foreground: 240 5.88% 90%;
  --nextui-content4: 240 5.2% 33.92%;
  --nextui-content4-foreground: 240 4.88% 83.92%;
  --nextui-default-50: 240 5.88% 10%;
  --nextui-default-100: 240 3.7% 15.88%;
  --nextui-default-200: 240 5.26% 26.08%;
  --nextui-default-300: 240 5.2% 33.92%;
  --nextui-default-400: 240 3.83% 46.08%;
  --nextui-default-500: 240 5.03% 64.9%;
  --nextui-default-600: 240 4.88% 83.92%;
  --nextui-default-700: 240 5.88% 90%;
  --nextui-default-800: 240 4.76% 95.88%;
  --nextui-default-900: 0 0% 98.04%;
  --nextui-default-foreground: 0 0% 100%;
  --nextui-default: 240 5.26% 26.08%;
  --nextui-primary-50: 211.84000000000003 100% 9.61%;
  --nextui-primary-100: 211.84000000000003 100% 19.22%;
  --nextui-primary-200: 212.24 100% 28.82%;
  --nextui-primary-300: 212.14 100% 38.43%;
  --nextui-primary-400: 212.01999999999998 100% 46.67%;
  --nextui-primary-500: 212.14 92.45% 58.43%;
  --nextui-primary-600: 212.24 92.45% 68.82%;
  --nextui-primary-700: 211.84000000000003 92.45% 79.22%;
  --nextui-primary-800: 211.84000000000003 92.45% 89.61%;
  --nextui-primary-900: 212.5 92.31% 94.9%;
  --nextui-primary-foreground: 0 0% 100%;
  --nextui-primary: 212.01999999999998 100% 46.67%;
  --nextui-secondary-50: 270 66.67% 9.41%;
  --nextui-secondary-100: 270 66.67% 18.82%;
  --nextui-secondary-200: 270 66.67% 28.24%;
  --nextui-secondary-300: 270 66.67% 37.65%;
  --nextui-secondary-400: 270 66.67% 47.06%;
  --nextui-secondary-500: 270 59.26% 57.65%;
  --nextui-secondary-600: 270 59.26% 68.24%;
  --nextui-secondary-700: 270 59.26% 78.82%;
  --nextui-secondary-800: 270 59.26% 89.41%;
  --nextui-secondary-900: 270 61.54% 94.9%;
  --nextui-secondary-foreground: 0 0% 100%;
  --nextui-secondary: 270 59.26% 57.65%;
  --nextui-success-50: 145.71000000000004 77.78% 8.82%;
  --nextui-success-100: 146.2 79.78% 17.45%;
  --nextui-success-200: 145.78999999999996 79.26% 26.47%;
  --nextui-success-300: 146.01 79.89% 35.1%;
  --nextui-success-400: 145.96000000000004 79.46% 43.92%;
  --nextui-success-500: 146.01 62.45% 55.1%;
  --nextui-success-600: 145.78999999999996 62.57% 66.47%;
  --nextui-success-700: 146.2 61.74% 77.45%;
  --nextui-success-800: 145.71000000000004 61.4% 88.82%;
  --nextui-success-900: 146.66999999999996 64.29% 94.51%;
  --nextui-success-foreground: 0 0% 0%;
  --nextui-success: 145.96000000000004 79.46% 43.92%;
  --nextui-warning-50: 37.139999999999986 75% 10.98%;
  --nextui-warning-100: 37.139999999999986 75% 21.96%;
  --nextui-warning-200: 36.95999999999998 73.96% 33.14%;
  --nextui-warning-300: 37.00999999999999 74.22% 44.12%;
  --nextui-warning-400: 37.02999999999997 91.27% 55.1%;
  --nextui-warning-500: 37.00999999999999 91.26% 64.12%;
  --nextui-warning-600: 36.95999999999998 91.24% 73.14%;
  --nextui-warning-700: 37.139999999999986 91.3% 81.96%;
  --nextui-warning-800: 37.139999999999986 91.3% 90.98%;
  --nextui-warning-900: 54.55000000000001 91.67% 95.29%;
  --nextui-warning-foreground: 0 0% 0%;
  --nextui-warning: 37.02999999999997 91.27% 55.1%;
  --nextui-danger-50: 340 84.91% 10.39%;
  --nextui-danger-100: 339.3299999999999 86.54% 20.39%;
  --nextui-danger-200: 339.11 85.99% 30.78%;
  --nextui-danger-300: 339 86.54% 40.78%;
  --nextui-danger-400: 339.20000000000005 90.36% 51.18%;
  --nextui-danger-500: 339 90% 60.78%;
  --nextui-danger-600: 339.11 90.6% 70.78%;
  --nextui-danger-700: 339.3299999999999 90% 80.39%;
  --nextui-danger-800: 340 91.84% 90.39%;
  --nextui-danger-900: 339.13 92% 95.1%;
  --nextui-danger-foreground: 0 0% 100%;
  --nextui-danger: 339.20000000000005 90.36% 51.18%;
  --nextui-divider-weight: 1px;
  --nextui-disabled-opacity: .5;
  --nextui-font-size-tiny: 0.75rem;
  --nextui-font-size-small: 0.875rem;
  --nextui-font-size-medium: 1rem;
  --nextui-font-size-large: 1.125rem;
  --nextui-line-height-tiny: 1rem;
  --nextui-line-height-small: 1.25rem;
  --nextui-line-height-medium: 1.5rem;
  --nextui-line-height-large: 1.75rem;
  --nextui-radius-small: 8px;
  --nextui-radius-medium: 12px;
  --nextui-radius-large: 14px;
  --nextui-border-width-small: 1px;
  --nextui-border-width-medium: 2px;
  --nextui-border-width-large: 3px;
  --nextui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.05), 0px 2px 10px 0px rgb(0 0 0 / 0.2), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --nextui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.06), 0px 2px 30px 0px rgb(0 0 0 / 0.22), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --nextui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.07), 0px 30px 60px 0px rgb(0 0 0 / 0.26), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --nextui-hover-opacity: .9;
}
.leading-inherit{
  line-height: inherit;
}
.bg-img-inherit{
  background-image: inherit;
}
.bg-clip-inherit{
  background-clip: inherit;
}
.text-fill-inherit{
  -webkit-text-fill-color: inherit;
}
.tap-highlight-transparent{
  -webkit-tap-highlight-color: transparent;
}
.input-search-cancel-button-none::-webkit-search-cancel-button{
  -webkit-appearance: none;
}
.transition-background{
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-colors-opacity{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-width{
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-height{
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-size{
  transition-property: width, height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-left{
  transition-property: left;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-opacity{
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-background{
  transition-property: transform, background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-colors{
  transition-property: transform, color, background, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-colors-opacity{
  transition-property: transform, color, background, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.scrollbar-hide{
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar{
  display: none;
}
.scrollbar-default{
  -ms-overflow-style: auto;
  scrollbar-width: auto;
}
.scrollbar-default::-webkit-scrollbar{
  display: block;
}
.\\[--cursor-hit-x\\:8px\\]{
  --cursor-hit-x: 8px;
}
.\\[--picker-height\\:224px\\]{
  --picker-height: 224px;
}
.\\[--scale-enter\\:100\\%\\]{
  --scale-enter: 100%;
}
.\\[--scale-exit\\:100\\%\\]{
  --scale-exit: 100%;
}
.\\[--scroll-shadow-size\\:100px\\]{
  --scroll-shadow-size: 100px;
}
.\\[--slide-enter\\:0px\\]{
  --slide-enter: 0px;
}
.\\[--slide-exit\\:80px\\]{
  --slide-exit: 80px;
}
.\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\]{
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.\\[scrollbar-width\\:none\\]{
  scrollbar-width: none;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

@keyframes ds-shimmer {
  100% {
    transform: translateX(100%);
  }
}

.ql-container {
  min-height: 200px;
}

.ql-editor {
  min-height: 200px;
}

.sub-accord-item h2 button div span {
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity))) !important;
  --tw-text-opacity: 1 !important;
  font-size: var(--nextui-font-size-small) !important;
  line-height: var(--nextui-line-height-small) !important;
}

.title-paragraph-break {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
}

.content-paragraph-break {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
}

/* ==========================================================================
   Sel DataGrid yang berisi tombol aksi

   SENGAJA DI LUAR @layer. Tailwind memangkas aturan di dalam @layer components
   bila nama kelas pada selektornya tidak pernah muncul di berkas sumber.
   .MuiDataGrid-cell dibuat MUI saat runtime, tidak pernah ditulis di kode kita,
   jadi aturan ini hilang dari CSS hasil build bila ditaruh di dalam layer -
   persis yang terjadi pada percobaan pertama.

   Alasan aturannya: sel DataGrid memakai display:block, sehingga isi sel yang
   lebih pendek dari tinggi baris menempel ke atas - kelihatan pada tombol aksi
   44px di dalam baris 52px. Cakupan dibatasi ke sel yang memang berisi tombol
   memakai :has(); mengubah SEMUA sel menjadi flex akan mematahkan pemotongan
   teks dengan elipsis yang diandalkan MUI pada sel teks biasa.
   ========================================================================== */
.MuiDataGrid-root .MuiDataGrid-cell:has(button) {
  display: flex !important;
  align-items: center;
}

/* Tombol di dalam sel dibuat ringkas 28px, sama dengan rilis produksi
   rilis/ui-admin. Aturan 44px versi .klh di styles/publik-klh.css tidak
   ber-layer, jadi pengecualian ini juga harus di luar layer. */
.MuiDataGrid-root .MuiDataGrid-cell:has(button) > div {
  align-items: center;
}
.MuiDataGrid-root .MuiDataGrid-cell button.h-10,
.MuiDataGrid-root .MuiDataGrid-cell button.h-8 {
  min-height: 0;
  height: 28px;
}
.MuiDataGrid-root .MuiDataGrid-cell button.h-10.w-10,
.MuiDataGrid-root .MuiDataGrid-cell button.h-8.w-8 {
  min-width: 0;
  width: 28px;
  border-radius: var(--r-sm, 8px);
}
.file\\:mr-2::file-selector-button{
  margin-right: 0.5rem;
}
.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}
.file\\:mr-4::file-selector-button{
  margin-right: 1rem;
}
.file\\:cursor-pointer::file-selector-button{
  cursor: pointer;
}
.file\\:rounded::file-selector-button{
  border-radius: 0.25rem;
}
.file\\:rounded-full::file-selector-button{
  border-radius: 9999px;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-blue-600::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.file\\:bg-primary-100::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-100) / var(--nextui-primary-100-opacity, var(--tw-bg-opacity)));
}
.file\\:bg-surface-3::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(235 242 240 / var(--tw-bg-opacity, 1));
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:px-2::file-selector-button{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:px-4::file-selector-button{
  padding-left: 1rem;
  padding-right: 1rem;
}
.file\\:py-0\\.5::file-selector-button{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.file\\:py-1::file-selector-button{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.file\\:py-2::file-selector-button{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-semibold::file-selector-button{
  font-weight: 600;
}
.file\\:text-primary-700::file-selector-button{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-700) / var(--nextui-primary-700-opacity, var(--tw-text-opacity)));
}
.file\\:text-white::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-danger::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.placeholder\\:text-foreground-500::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-500) / var(--nextui-foreground-500-opacity, var(--tw-text-opacity)));
}
.placeholder\\:text-ink-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(117 132 127 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-primary::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.placeholder\\:text-secondary::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.placeholder\\:text-success-600::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-600) / var(--nextui-success-600-opacity, var(--tw-text-opacity)));
}
.placeholder\\:text-warning-600::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-600) / var(--nextui-warning-600-opacity, var(--tw-text-opacity)));
}
.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}
.before\\:inset-0::before{
  content: var(--tw-content);
  inset: 0px;
}
.before\\:left-\\[-50\\%\\]::before{
  content: var(--tw-content);
  left: -50%;
}
.before\\:top-\\[17px\\]::before{
  content: var(--tw-content);
  top: 17px;
}
.before\\:z-0::before{
  content: var(--tw-content);
  z-index: 0;
}
.before\\:z-\\[-1\\]::before{
  content: var(--tw-content);
  z-index: -1;
}
.before\\:box-border::before{
  content: var(--tw-content);
  box-sizing: border-box;
}
.before\\:block::before{
  content: var(--tw-content);
  display: block;
}
.before\\:hidden::before{
  content: var(--tw-content);
  display: none;
}
.before\\:h-0\\.5::before{
  content: var(--tw-content);
  height: 0.125rem;
}
.before\\:h-11::before{
  content: var(--tw-content);
  height: 2.75rem;
}
.before\\:h-2\\.5::before{
  content: var(--tw-content);
  height: 0.625rem;
}
.before\\:h-\\[3px\\]::before{
  content: var(--tw-content);
  height: 3px;
}
.before\\:h-px::before{
  content: var(--tw-content);
  height: 1px;
}
.before\\:w-0::before{
  content: var(--tw-content);
  width: 0px;
}
.before\\:w-11::before{
  content: var(--tw-content);
  width: 2.75rem;
}
.before\\:w-2\\.5::before{
  content: var(--tw-content);
  width: 0.625rem;
}
.before\\:w-6::before{
  content: var(--tw-content);
  width: 1.5rem;
}
.before\\:w-full::before{
  content: var(--tw-content);
  width: 100%;
}
.before\\:-translate-x-full::before{
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:-translate-y-1::before{
  content: var(--tw-content);
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rotate-0::before{
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rotate-45::before{
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes shimmer{
  100%{
    content: var(--tw-content);
    transform: translateX(100%);
  }
}
.before\\:animate-\\[shimmer_2s_infinite\\]::before{
  content: var(--tw-content);
  animation: shimmer 2s infinite;
}
.before\\:animate-none::before{
  content: var(--tw-content);
  animation: none;
}
.before\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\]::before{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-medium) * 0.5);
}
.before\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\]::before{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-medium) * 0.6);
}
.before\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\]::before{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-medium) * 0.7);
}
.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:rounded-none::before{
  content: var(--tw-content);
  border-radius: 0px;
}
.before\\:rounded-sm::before{
  content: var(--tw-content);
  border-radius: 0.125rem;
}
.before\\:border-2::before{
  content: var(--tw-content);
  border-width: 2px;
}
.before\\:border-t::before{
  content: var(--tw-content);
  border-top-width: 1px;
}
.before\\:border-solid::before{
  content: var(--tw-content);
  border-style: solid;
}
.before\\:border-content4\\/30::before{
  content: var(--tw-content);
  border-color: hsl(var(--nextui-content4) / 0.3);
}
.before\\:border-danger::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.before\\:border-default::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-border-opacity)));
}
.before\\:bg-content1::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content1) / var(--nextui-content1-opacity, var(--tw-bg-opacity)));
}
.before\\:bg-current::before{
  content: var(--tw-content);
  background-color: currentColor;
}
.before\\:bg-danger::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.before\\:bg-danger\\/20::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-danger) / 0.2);
}
.before\\:bg-default\\/60::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-default) / 0.6);
}
.before\\:bg-foreground::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.before\\:bg-g-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(7 136 125 / var(--tw-bg-opacity, 1));
}
.before\\:bg-line::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(225 232 230 / var(--tw-bg-opacity, 1));
}
.before\\:bg-primary::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.before\\:bg-primary\\/20::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-primary) / 0.2);
}
.before\\:bg-secondary::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.before\\:bg-secondary\\/20::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-secondary) / 0.2);
}
.before\\:bg-success::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.before\\:bg-success\\/20::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-success) / 0.2);
}
.before\\:bg-warning::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.before\\:bg-warning\\/20::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-warning) / 0.2);
}
.before\\:bg-gradient-to-r::before{
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.before\\:from-transparent::before{
  content: var(--tw-content);
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.before\\:via-content4::before{
  content: var(--tw-content);
  --tw-gradient-to: hsl(var(--nextui-content4) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--nextui-content4) / var(--nextui-content4-opacity, 1)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.before\\:to-transparent::before{
  content: var(--tw-content);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.before\\:opacity-0::before{
  content: var(--tw-content);
  opacity: 0;
}
.before\\:opacity-100::before{
  content: var(--tw-content);
  opacity: 1;
}
.before\\:shadow-small::before{
  content: var(--tw-content);
  --tw-shadow: var(--nextui-box-shadow-small);
  --tw-shadow-colored: var(--nextui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.before\\:transition-colors::before{
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.before\\:transition-none::before{
  content: var(--tw-content);
  transition-property: none;
}
.before\\:transition-transform::before{
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.before\\:duration-150::before{
  content: var(--tw-content);
  transition-duration: 150ms;
}
.before\\:content-\\[\\'\\'\\]::before{
  --tw-content: '';
  content: var(--tw-content);
}
.before\\:transition-width::before{
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-0::after{
  content: var(--tw-content);
  inset: 0px;
}
.after\\:-bottom-1::after{
  content: var(--tw-content);
  bottom: -0.25rem;
}
.after\\:-bottom-\\[2px\\]::after{
  content: var(--tw-content);
  bottom: -2px;
}
.after\\:bottom-0::after{
  content: var(--tw-content);
  bottom: 0px;
}
.after\\:left-0::after{
  content: var(--tw-content);
  left: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:right-0::after{
  content: var(--tw-content);
  right: 0px;
}
.after\\:top-0::after{
  content: var(--tw-content);
  top: 0px;
}
.after\\:-z-10::after{
  content: var(--tw-content);
  z-index: -10;
}
.after\\:z-0::after{
  content: var(--tw-content);
  z-index: 0;
}
.after\\:ml-0\\.5::after{
  content: var(--tw-content);
  margin-left: 0.125rem;
}
.after\\:ms-0\\.5::after{
  content: var(--tw-content);
  margin-inline-start: 0.125rem;
}
.after\\:block::after{
  content: var(--tw-content);
  display: block;
}
.after\\:h-0::after{
  content: var(--tw-content);
  height: 0px;
}
.after\\:h-4::after{
  content: var(--tw-content);
  height: 1rem;
}
.after\\:h-5::after{
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:h-\\[2px\\]::after{
  content: var(--tw-content);
  height: 2px;
}
.after\\:h-divider::after{
  content: var(--tw-content);
  height: var(--nextui-divider-weight);
}
.after\\:h-full::after{
  content: var(--tw-content);
  height: 100%;
}
.after\\:h-px::after{
  content: var(--tw-content);
  height: 1px;
}
.after\\:w-0::after{
  content: var(--tw-content);
  width: 0px;
}
.after\\:w-4::after{
  content: var(--tw-content);
  width: 1rem;
}
.after\\:w-5::after{
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:w-6::after{
  content: var(--tw-content);
  width: 1.5rem;
}
.after\\:w-\\[80\\%\\]::after{
  content: var(--tw-content);
  width: 80%;
}
.after\\:w-full::after{
  content: var(--tw-content);
  width: 100%;
}
.after\\:origin-center::after{
  content: var(--tw-content);
  transform-origin: center;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:translate-y-1::after{
  content: var(--tw-content);
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rotate-0::after{
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:scale-50::after{
  content: var(--tw-content);
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.large\\)\\/2\\)\\]::after{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-large) / 2);
}
.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\]::after{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-medium) * 0.5);
}
.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\]::after{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-medium) * 0.6);
}
.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\]::after{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-medium) * 0.7);
}
.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\/3\\)\\]::after{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-medium) / 3);
}
.after\\:rounded-\\[calc\\(theme\\(borderRadius\\.small\\)\\/3\\)\\]::after{
  content: var(--tw-content);
  border-radius: calc(var(--nextui-radius-small) / 3);
}
.after\\:rounded-full::after{
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:rounded-none::after{
  content: var(--tw-content);
  border-radius: 0px;
}
.after\\:rounded-xl::after{
  content: var(--tw-content);
  border-radius: 0.75rem;
}
.after\\:\\!bg-danger::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity))) !important;
}
.after\\:bg-background::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-content1::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content1) / var(--nextui-content1-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-content3::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content3) / var(--nextui-content3-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-current::after{
  content: var(--tw-content);
  background-color: currentColor;
}
.after\\:bg-danger::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-default::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-default-foreground::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-divider::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-divider) / var(--nextui-divider-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-foreground::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-primary::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-secondary::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-success::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.after\\:bg-warning::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.after\\:text-danger::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.after\\:text-danger-foreground::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:text-default-foreground::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:text-primary-foreground::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:text-secondary-foreground::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:text-success-foreground::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:text-warning-foreground::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:opacity-0::after{
  content: var(--tw-content);
  opacity: 0;
}
.after\\:opacity-100::after{
  content: var(--tw-content);
  opacity: 1;
}
.after\\:shadow-\\[0_1px_0px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]::after{
  content: var(--tw-content);
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:shadow-small::after{
  content: var(--tw-content);
  --tw-shadow: var(--nextui-box-shadow-small);
  --tw-shadow-colored: var(--nextui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:transition-all::after{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.after\\:transition-none::after{
  content: var(--tw-content);
  transition-property: none;
}
.after\\:transition-transform::after{
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.after\\:\\!duration-200::after{
  content: var(--tw-content);
  transition-duration: 200ms !important;
}
.after\\:duration-150::after{
  content: var(--tw-content);
  transition-duration: 150ms;
}
.after\\:\\!ease-linear::after{
  content: var(--tw-content);
  transition-timing-function: linear !important;
}
.after\\:content-\\[\\'\\'\\]::after{
  --tw-content: '';
  content: var(--tw-content);
}
.after\\:content-\\[\\'\\*\\'\\]::after{
  --tw-content: '*';
  content: var(--tw-content);
}
.after\\:transition-background::after{
  content: var(--tw-content);
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:transition-width::after{
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:transition-height::after{
  content: var(--tw-content);
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:transition-transform-opacity::after{
  content: var(--tw-content);
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.first\\:-ml-0\\.5:first-child{
  margin-left: -0.125rem;
}
.first\\:mt-2:first-child{
  margin-top: 0.5rem;
}
.first\\:mt-5:first-child{
  margin-top: 1.25rem;
}
.first\\:rounded-s-full:first-child{
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}
.first\\:rounded-s-large:first-child{
  border-start-start-radius: var(--nextui-radius-large);
  border-end-start-radius: var(--nextui-radius-large);
}
.first\\:rounded-s-lg:first-child{
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.first\\:rounded-s-medium:first-child{
  border-start-start-radius: var(--nextui-radius-medium);
  border-end-start-radius: var(--nextui-radius-medium);
}
.first\\:rounded-s-none:first-child{
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}
.first\\:rounded-s-small:first-child{
  border-start-start-radius: var(--nextui-radius-small);
  border-end-start-radius: var(--nextui-radius-small);
}
.first\\:before\\:hidden:first-child::before{
  content: var(--tw-content);
  display: none;
}
.first\\:before\\:rounded-s-lg:first-child::before{
  content: var(--tw-content);
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.last\\:mb-5:last-child{
  margin-bottom: 1.25rem;
}
.last\\:rounded-e-full:last-child{
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}
.last\\:rounded-e-large:last-child{
  border-start-end-radius: var(--nextui-radius-large);
  border-end-end-radius: var(--nextui-radius-large);
}
.last\\:rounded-e-lg:last-child{
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.last\\:rounded-e-medium:last-child{
  border-start-end-radius: var(--nextui-radius-medium);
  border-end-end-radius: var(--nextui-radius-medium);
}
.last\\:rounded-e-none:last-child{
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}
.last\\:rounded-e-small:last-child{
  border-start-end-radius: var(--nextui-radius-small);
  border-end-end-radius: var(--nextui-radius-small);
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:before\\:rounded-e-lg:last-child::before{
  content: var(--tw-content);
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.first-of-type\\:rounded-e-none:first-of-type{
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}
.last-of-type\\:rounded-s-none:last-of-type{
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}
.autofill\\:bg-transparent:autofill{
  background-color: transparent;
}
.focus-within\\:border-blue-400:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.focus-within\\:border-blue-500:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus-within\\:border-danger:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.focus-within\\:border-default-400:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-border-opacity)));
}
.focus-within\\:border-default-foreground:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-border-opacity)));
}
.focus-within\\:border-pb-aksen:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(37 102 77 / var(--tw-border-opacity, 1));
}
.focus-within\\:border-primary:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.focus-within\\:border-secondary:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.focus-within\\:border-success:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.focus-within\\:border-warning:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.focus-within\\:bg-blue-100:focus-within{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.focus-within\\:bg-blue-50\\/30:focus-within{
  background-color: rgb(239 246 255 / 0.3);
}
.focus-within\\:bg-blue-50\\/60:focus-within{
  background-color: rgb(239 246 255 / 0.6);
}
.focus-within\\:bg-danger-50:focus-within{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:bg-primary-50:focus-within{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:bg-secondary-50:focus-within{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:bg-success-50:focus-within{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:bg-warning-50:focus-within{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:ring-1:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-blue-200:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.focus-within\\:ring-blue-400:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.focus-within\\:ring-blue-500\\/20:focus-within{
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.focus-within\\:after\\:w-full:focus-within::after{
  content: var(--tw-content);
  width: 100%;
}
.hover\\:-translate-x-0:hover{
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-125:hover{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-danger:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.hover\\:border-default:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-border-opacity)));
}
.hover\\:border-default-300:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-300) / var(--nextui-default-300-opacity, var(--tw-border-opacity)));
}
.hover\\:border-default-400:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-border-opacity)));
}
.hover\\:border-g-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(7 136 125 / var(--tw-border-opacity, 1));
}
.hover\\:border-g-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(0 89 82 / var(--tw-border-opacity, 1));
}
.hover\\:border-line-strong:hover{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 207 / var(--tw-border-opacity, 1));
}
.hover\\:border-pb-aksen:hover{
  --tw-border-opacity: 1;
  border-color: rgb(37 102 77 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.hover\\:border-secondary:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.hover\\:border-success:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.hover\\:border-warning:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.hover\\:\\!bg-foreground:hover{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity))) !important;
}
.hover\\:bg-amber-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-b-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(11 82 157 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-100\\/50:hover{
  background-color: rgb(219 234 254 / 0.5);
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-danger:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-danger-50:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-default-100:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-default-200:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-emerald-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-g-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(222 242 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-g-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(184 234 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-g-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 69 63 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-line-strong:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 207 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-o-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 143 56 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-o-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(214 99 5 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pb-kabut:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 234 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-50:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary-50:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-success-50:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-surface-2:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 249 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-surface-3:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(235 242 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-50:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:text-g-700:hover{
  --tw-text-opacity: 1;
  color: rgb(0 69 63 / var(--tw-text-opacity, 1));
}
.hover\\:text-ink-700:hover{
  --tw-text-opacity: 1;
  color: rgb(40 56 53 / var(--tw-text-opacity, 1));
}
.hover\\:text-ink-900:hover{
  --tw-text-opacity: 1;
  color: rgb(16 32 29 / var(--tw-text-opacity, 1));
}
.hover\\:text-pb-aksen:hover{
  --tw-text-opacity: 1;
  color: rgb(37 102 77 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:\\!opacity-100:hover{
  opacity: 1 !important;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-70:hover{
  opacity: 0.7;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:opacity-85:hover{
  opacity: 0.85;
}
.hover\\:shadow-ds-2:hover{
  --tw-shadow: 0 2px 6px rgba(0,54,49,.08),0 6px 16px rgba(0,54,49,.07);
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color), 0 6px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:brightness-95:hover{
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:file\\:bg-blue-700::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:file\\:bg-primary-200::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-200) / var(--nextui-primary-200-opacity, var(--tw-bg-opacity)));
}
.hover\\:after\\:bg-danger\\/20:hover::after{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-danger) / 0.2);
}
.hover\\:after\\:bg-foreground\\/10:hover::after{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-foreground) / 0.1);
}
.hover\\:after\\:bg-primary\\/20:hover::after{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-primary) / 0.2);
}
.hover\\:after\\:bg-secondary\\/20:hover::after{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-secondary) / 0.2);
}
.hover\\:after\\:bg-success\\/20:hover::after{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-success) / 0.2);
}
.hover\\:after\\:bg-warning\\/20:hover::after{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-warning) / 0.2);
}
.hover\\:after\\:opacity-100:hover::after{
  content: var(--tw-content);
  opacity: 1;
}
.focus-within\\:hover\\:border-danger:hover:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.focus-within\\:hover\\:border-default-foreground:hover:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-border-opacity)));
}
.focus-within\\:hover\\:border-primary:hover:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.focus-within\\:hover\\:border-secondary:hover:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.focus-within\\:hover\\:border-success:hover:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.focus-within\\:hover\\:border-warning:hover:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.focus-within\\:hover\\:bg-default-100:hover:focus-within{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-g-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(7 136 125 / var(--tw-border-opacity, 1));
}
.focus\\:border-transparent:focus{
  border-color: transparent;
}
.focus\\:bg-danger-400\\/50:focus{
  background-color: hsl(var(--nextui-danger-400) / 0.5);
}
.focus\\:bg-default-400\\/50:focus{
  background-color: hsl(var(--nextui-default-400) / 0.5);
}
.focus\\:bg-primary-400\\/50:focus{
  background-color: hsl(var(--nextui-primary-400) / 0.5);
}
.focus\\:bg-secondary-400\\/50:focus{
  background-color: hsl(var(--nextui-secondary-400) / 0.5);
}
.focus\\:bg-success-400\\/50:focus{
  background-color: hsl(var(--nextui-success-400) / 0.5);
}
.focus\\:bg-warning-400\\/50:focus{
  background-color: hsl(var(--nextui-warning-400) / 0.5);
}
.focus\\:underline:focus{
  text-decoration-line: underline;
}
.focus\\:shadow-sm:focus{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:outline-0:focus{
  outline-width: 0px;
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[3px\\]:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500\\/50:focus{
  --tw-ring-color: rgb(59 130 246 / 0.5);
}
.focus\\:ring-g-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(222 242 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-primary:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-ring-opacity)));
}
.focus\\:ring-primary-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-primary-500) / var(--nextui-primary-500-opacity, var(--tw-ring-opacity)));
}
.focus\\:ring-primary-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-primary-600) / var(--nextui-primary-600-opacity, var(--tw-ring-opacity)));
}
.focus-visible\\:z-10:focus-visible{
  z-index: 10;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:outline-2:focus-visible{
  outline-width: 2px;
}
.focus-visible\\:outline-offset-2:focus-visible{
  outline-offset: 2px;
}
.focus-visible\\:outline-focus:focus-visible{
  outline-color: hsl(var(--nextui-focus) / var(--nextui-focus-opacity, 1));
}
.active\\:bg-default-200:active{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.active\\:bg-default-300:active{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-300) / var(--nextui-default-300-opacity, var(--tw-bg-opacity)));
}
.active\\:underline:active{
  text-decoration-line: underline;
}
.active\\:\\!opacity-70:active{
  opacity: 0.7 !important;
}
.active\\:opacity-50:active{
  opacity: 0.5;
}
.active\\:opacity-disabled:active{
  opacity: var(--nextui-disabled-opacity);
}
.disabled\\:cursor-default:disabled{
  cursor: default;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:bg-surface-2:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(245 249 248 / var(--tw-bg-opacity, 1));
}
.disabled\\:text-ink-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(117 132 127 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-45:disabled{
  opacity: 0.45;
}
.group:hover .group-hover\\:block{
  display: block;
}
.group:hover .group-hover\\:hidden{
  display: none;
}
.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-12{
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-current{
  border-color: currentColor;
}
.group:hover .group-hover\\:text-current{
  color: currentColor;
}
.has-\\[\\:disabled\\]\\:opacity-60:has(:disabled){
  opacity: 0.6;
}
.aria-expanded\\:scale-\\[0\\.97\\][aria-expanded="true"]{
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.aria-expanded\\:opacity-70[aria-expanded="true"]{
  opacity: 0.7;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[loaded\\=true\\]\\:pointer-events-auto[data-loaded="true"]{
  pointer-events: auto;
}
.data-\\[visible\\=true\\]\\:pointer-events-auto[data-visible="true"]{
  pointer-events: auto;
}
.data-\\[focus-visible\\=true\\]\\:z-10[data-focus-visible="true"]{
  z-index: 10;
}
.data-\\[focused\\=true\\]\\:z-10[data-focused="true"]{
  z-index: 10;
}
.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_10px\\)\\][data-has-label="true"]{
  margin-top: calc(var(--nextui-font-size-small) + 10px);
}
.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_12px\\)\\][data-has-label="true"]{
  margin-top: calc(var(--nextui-font-size-small) + 12px);
}
.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_8px\\)\\][data-has-label="true"]{
  margin-top: calc(var(--nextui-font-size-small) + 8px);
}
.data-\\[open\\=true\\]\\:block[data-open="true"]{
  display: block;
}
.data-\\[open\\=true\\]\\:flex[data-open="true"]{
  display: flex;
}
.data-\\[hidden\\=true\\]\\:hidden[data-hidden="true"]{
  display: none;
}
.data-\\[inert\\=true\\]\\:hidden[data-inert="true"]{
  display: none;
}
.data-\\[justify\\=end\\]\\:flex-grow[data-justify="end"]{
  flex-grow: 1;
}
.data-\\[justify\\=start\\]\\:flex-grow[data-justify="start"]{
  flex-grow: 1;
}
.data-\\[justify\\=end\\]\\:basis-0[data-justify="end"]{
  flex-basis: 0px;
}
.data-\\[justify\\=start\\]\\:basis-0[data-justify="start"]{
  flex-basis: 0px;
}
.data-\\[focus-visible\\=true\\]\\:-translate-x-3[data-focus-visible="true"]{
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[hover\\=true\\]\\:-translate-x-3[data-hover="true"]{
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[hover\\=true\\]\\:translate-x-0[data-hover="true"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[before\\=true\\]\\:rotate-180[data-before="true"]{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[direction\\=ascending\\]\\:rotate-180[data-direction="ascending"]{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[open\\=true\\]\\:-rotate-90[data-open="true"]{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[open\\=true\\]\\:rotate-180[data-open="true"]{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[active\\=true\\]\\:scale-100[data-active="true"]{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[active\\=true\\]\\:scale-110[data-active="true"]{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[invisible\\=true\\]\\:scale-0[data-invisible="true"]{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[pressed\\=true\\]\\:scale-100[data-pressed="true"]{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[pressed\\=true\\]\\:scale-\\[0\\.97\\][data-pressed="true"]{
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[disabled\\=true\\]\\:cursor-default[data-disabled="true"]{
  cursor: default;
}
.data-\\[disabled\\=true\\]\\:cursor-not-allowed[data-disabled="true"]{
  cursor: not-allowed;
}
.data-\\[dragging\\=true\\]\\:cursor-grabbing[data-dragging="true"]{
  cursor: grabbing;
}
.data-\\[readonly\\=true\\]\\:cursor-default[data-readonly="true"]{
  cursor: default;
}
.data-\\[sortable\\=true\\]\\:cursor-pointer[data-sortable="true"]{
  cursor: pointer;
}
.data-\\[unavailable\\=true\\]\\:cursor-default[data-unavailable="true"]{
  cursor: default;
}
.data-\\[visible\\=true\\]\\:cursor-pointer[data-visible="true"]{
  cursor: pointer;
}
.data-\\[orientation\\=horizontal\\]\\:flex-row[data-orientation="horizontal"]{
  flex-direction: row;
}
.data-\\[has-helper\\=true\\]\\:items-start[data-has-helper="true"]{
  align-items: flex-start;
}
.data-\\[justify\\=start\\]\\:justify-start[data-justify="start"]{
  justify-content: flex-start;
}
.data-\\[justify\\=end\\]\\:justify-end[data-justify="end"]{
  justify-content: flex-end;
}
.data-\\[justify\\=center\\]\\:justify-center[data-justify="center"]{
  justify-content: center;
}
.data-\\[loaded\\=true\\]\\:overflow-visible[data-loaded="true"]{
  overflow: visible;
}
.data-\\[has-multiple-rows\\=true\\]\\:rounded-large[data-has-multiple-rows="true"]{
  border-radius: var(--nextui-radius-large);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:rounded-full[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  border-radius: 9999px;
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:rounded-full[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  border-radius: 9999px;
}
.data-\\[menu-open\\=true\\]\\:border-none[data-menu-open="true"]{
  border-style: none;
}
.data-\\[active\\=true\\]\\:border-danger[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-danger-400[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger-400) / var(--nextui-danger-400-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-default-300[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-300) / var(--nextui-default-300-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-default-400[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-foreground[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-primary[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-secondary[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-success[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:border-warning[data-active="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:border-danger[data-focus="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:border-default-400[data-focus="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:border-default-foreground[data-focus="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:border-primary[data-focus="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:border-secondary[data-focus="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:border-success[data-focus="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:border-warning[data-focus="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:border-danger[data-hover="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:border-default[data-hover="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:border-default-400[data-hover="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:border-primary[data-hover="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:border-secondary[data-hover="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:border-success[data-hover="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:border-warning[data-hover="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:border-danger[data-open="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:border-default-400[data-open="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:border-default-foreground[data-open="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:border-primary[data-open="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:border-secondary[data-open="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:border-success[data-open="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:border-warning[data-open="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.data-\\[selected\\=true\\]\\:border-primary[data-selected="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:bg-danger[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-danger-100[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-danger-200[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-200) / var(--nextui-danger-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-default-200[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-default-400[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-primary[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-primary-200[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-200) / var(--nextui-primary-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-secondary[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-secondary-200[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-200) / var(--nextui-secondary-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-success[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-success-200[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-200) / var(--nextui-success-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-warning[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:bg-warning-200[data-active="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-200) / var(--nextui-warning-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:\\!bg-danger[data-hover="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-danger-100[data-hover="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-bg-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-default[data-hover="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-bg-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-primary[data-hover="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-secondary[data-hover="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-success[data-hover="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-warning[data-hover="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:bg-content2[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content2) / var(--nextui-content2-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-danger-100[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-danger-50[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-danger\\/20[data-hover="true"]{
  background-color: hsl(var(--nextui-danger) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-default[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-default-100[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-default-200[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-default\\/40[data-hover="true"]{
  background-color: hsl(var(--nextui-default) / 0.4);
}
.data-\\[hover\\=true\\]\\:bg-foreground-200[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground-200) / var(--nextui-foreground-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-primary[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-primary-50[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-primary\\/20[data-hover="true"]{
  background-color: hsl(var(--nextui-primary) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-secondary[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-secondary-50[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-secondary\\/20[data-hover="true"]{
  background-color: hsl(var(--nextui-secondary) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-success[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-success-100[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-100) / var(--nextui-success-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-success-50[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-success\\/20[data-hover="true"]{
  background-color: hsl(var(--nextui-success) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-transparent[data-hover="true"]{
  background-color: transparent;
}
.data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-warning-100[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-100) / var(--nextui-warning-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-warning-50[data-hover="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:bg-warning\\/20[data-hover="true"]{
  background-color: hsl(var(--nextui-warning) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-white\\/10[data-hover="true"]{
  background-color: rgb(255 255 255 / 0.1);
}
.data-\\[hover\\]\\:bg-danger-200[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-200) / var(--nextui-danger-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-danger-50[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-default-100[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-primary-200[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-200) / var(--nextui-primary-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-primary-50[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-secondary-200[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-200) / var(--nextui-secondary-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-secondary-50[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-success-200[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-200) / var(--nextui-success-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-success-50[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-warning-100[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-100) / var(--nextui-warning-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\]\\:bg-warning-200[data-hover]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-200) / var(--nextui-warning-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=false\\]\\:bg-default-200[data-in-range="false"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=true\\]\\:bg-background\\/50[data-in-range="true"]{
  background-color: hsl(var(--nextui-background) / 0.5);
}
.data-\\[in-range\\=true\\]\\:bg-danger[data-in-range="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=true\\]\\:bg-foreground[data-in-range="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=true\\]\\:bg-primary[data-in-range="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=true\\]\\:bg-secondary[data-in-range="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=true\\]\\:bg-success[data-in-range="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=true\\]\\:bg-warning[data-in-range="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[loaded\\=true\\]\\:\\!bg-transparent[data-loaded="true"]{
  background-color: transparent !important;
}
.data-\\[open\\=true\\]\\:bg-primary\\/20[data-open="true"]{
  background-color: hsl(var(--nextui-primary) / 0.2);
}
.data-\\[open\\=true\\]\\:bg-white\\/10[data-open="true"]{
  background-color: rgb(255 255 255 / 0.1);
}
.data-\\[selected\\=true\\]\\:bg-danger[data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:bg-default[data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:bg-foreground[data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:bg-primary[data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:bg-secondary[data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:bg-success[data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:bg-warning[data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-foreground[data-hover="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-primary[data-hover="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-secondary[data-hover="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-success[data-hover="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:bg-transparent[data-outside-month="true"][data-range-selection="true"][data-selected="true"]{
  background-color: transparent;
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-danger[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-primary[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-secondary[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-success[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-warning[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-danger[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-primary[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-secondary[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-success[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-warning[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[has-end-content\\=true\\]\\:pe-1\\.5[data-has-end-content="true"]{
  padding-inline-end: 0.375rem;
}
.data-\\[has-helper\\=true\\]\\:pb-\\[calc\\(theme\\(fontSize\\.tiny\\)_\\+8px\\)\\][data-has-helper="true"]{
  padding-bottom: calc(var(--nextui-font-size-tiny) + 8px);
}
.data-\\[has-helper\\=true\\]\\:pb-\\[calc\\(theme\\(fontSize\\.tiny\\)_\\+_8px\\)\\][data-has-helper="true"]{
  padding-bottom: calc(var(--nextui-font-size-tiny) + 8px);
}
.data-\\[has-start-content\\=true\\]\\:ps-1\\.5[data-has-start-content="true"]{
  padding-inline-start: 0.375rem;
}
.data-\\[has-title\\=true\\]\\:pt-1[data-has-title="true"]{
  padding-top: 0.25rem;
}
.data-\\[active\\=true\\]\\:font-semibold[data-active="true"]{
  font-weight: 600;
}
.data-\\[active\\=true\\]\\:text-danger-foreground[data-active="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:text-default-foreground[data-active="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:text-primary-foreground[data-active="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:text-secondary-foreground[data-active="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:text-success-foreground[data-active="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:text-warning-foreground[data-active="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[disabled\\=true\\]\\:text-default-300[data-disabled="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-300) / var(--nextui-default-300-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-danger-300[data-placeholder="true"][data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-300) / var(--nextui-danger-300-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-foreground-500[data-placeholder="true"][data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-500) / var(--nextui-foreground-500-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-primary-300[data-placeholder="true"][data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-300) / var(--nextui-primary-300-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-secondary-300[data-placeholder="true"][data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-300) / var(--nextui-secondary-300-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-success-400[data-placeholder="true"][data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-400) / var(--nextui-success-400-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-warning-400[data-placeholder="true"][data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-400) / var(--nextui-warning-400-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:text-danger[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:text-foreground[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:text-primary[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:text-secondary[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:text-success-600[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-600) / var(--nextui-success-600-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:text-warning-600[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-600) / var(--nextui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[has-value\\=true\\]\\:text-default-foreground[data-has-value="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:\\!text-danger-foreground[data-hover="true"]{
  --tw-text-opacity: 1 !important;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-primary-foreground[data-hover="true"]{
  --tw-text-opacity: 1 !important;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-secondary-foreground[data-hover="true"]{
  --tw-text-opacity: 1 !important;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-success-foreground[data-hover="true"]{
  --tw-text-opacity: 1 !important;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-warning-foreground[data-hover="true"]{
  --tw-text-opacity: 1 !important;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity))) !important;
}
.data-\\[hover\\=true\\]\\:text-danger[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-danger-500[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-500) / var(--nextui-danger-500-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-default-500[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-500) / var(--nextui-default-500-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-default-foreground[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-foreground-400[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-400) / var(--nextui-foreground-400-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-foreground-600[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-600) / var(--nextui-foreground-600-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-primary[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-primary-400[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-400) / var(--nextui-primary-400-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-primary-foreground[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-secondary[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-secondary-400[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-400) / var(--nextui-secondary-400-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-secondary-foreground[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-success[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-success-600[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-600) / var(--nextui-success-600-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-warning[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-warning-600[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-600) / var(--nextui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:text-danger[data-editable="true"][data-invalid="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.data-\\[invalid\\=true\\]\\:text-danger-300[data-invalid="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-300) / var(--nextui-danger-300-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-background[data-hover="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-primary-foreground[data-hover="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-secondary-foreground[data-hover="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:text-default-300[data-outside-month="true"][data-range-selection="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-300) / var(--nextui-default-300-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-500[data-range-selection="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-500) / var(--nextui-danger-500-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-foreground[data-range-selection="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary[data-range-selection="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary[data-range-selection="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-600[data-range-selection="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-600) / var(--nextui-success-600-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-500[data-range-selection="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-500) / var(--nextui-warning-500-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-background[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-background[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-background[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-danger[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-danger-foreground[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-default-foreground[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-primary[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-primary-foreground[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-secondary[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-secondary-foreground[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-success-600[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-600) / var(--nextui-success-600-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-success-foreground[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-warning-600[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-600) / var(--nextui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:text-warning-foreground[data-selected="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[unavailable\\=true\\]\\:text-default-300[data-unavailable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-300) / var(--nextui-default-300-opacity, var(--tw-text-opacity)));
}
.data-\\[unavailable\\=true\\]\\:line-through[data-unavailable="true"]{
  text-decoration-line: line-through;
}
.data-\\[disabled\\=true\\]\\:data-\\[outside-month\\=true\\]\\:opacity-0[data-outside-month="true"][data-disabled="true"]{
  opacity: 0;
}
.data-\\[disabled\\=true\\]\\:opacity-30[data-disabled="true"]{
  opacity: 0.3;
}
.data-\\[hover-unselected\\=true\\]\\:opacity-disabled[data-hover-unselected="true"]{
  opacity: var(--nextui-disabled-opacity);
}
.data-\\[hover\\=true\\]\\:opacity-hover[data-hover="true"]{
  opacity: var(--nextui-hover-opacity);
}
.data-\\[in-range\\=true\\]\\:opacity-100[data-in-range="true"]{
  opacity: 1;
}
.data-\\[invisible\\=true\\]\\:opacity-0[data-invisible="true"]{
  opacity: 0;
}
.data-\\[loaded\\=true\\]\\:opacity-100[data-loaded="true"]{
  opacity: 1;
}
.data-\\[moving\\]\\:opacity-100[data-moving]{
  opacity: 1;
}
.data-\\[pressed\\=true\\]\\:opacity-50[data-pressed="true"]{
  opacity: 0.5;
}
.data-\\[pressed\\=true\\]\\:opacity-70[data-pressed="true"]{
  opacity: 0.7;
}
.data-\\[visible\\=true\\]\\:opacity-100[data-visible="true"]{
  opacity: 1;
}
.data-\\[active\\=true\\]\\:shadow-md[data-active="true"]{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[hover\\=true\\]\\:shadow-lg[data-hover="true"]{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:shadow-md[data-selection-end="true"][data-selected="true"]{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:shadow-md[data-selection-start="true"][data-selected="true"]{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:shadow-md[data-selected="true"]{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:shadow-none[data-selected="true"]{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[active\\=true\\]\\:shadow-danger\\/40[data-active="true"]{
  --tw-shadow-color: hsl(var(--nextui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-default\\/50[data-active="true"]{
  --tw-shadow-color: hsl(var(--nextui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-primary\\/40[data-active="true"]{
  --tw-shadow-color: hsl(var(--nextui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-secondary\\/40[data-active="true"]{
  --tw-shadow-color: hsl(var(--nextui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-success\\/40[data-active="true"]{
  --tw-shadow-color: hsl(var(--nextui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-warning\\/40[data-active="true"]{
  --tw-shadow-color: hsl(var(--nextui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-danger\\/30[data-hover="true"]{
  --tw-shadow-color: hsl(var(--nextui-danger) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-default\\/50[data-hover="true"]{
  --tw-shadow-color: hsl(var(--nextui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-primary\\/30[data-hover="true"]{
  --tw-shadow-color: hsl(var(--nextui-primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-secondary\\/30[data-hover="true"]{
  --tw-shadow-color: hsl(var(--nextui-secondary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-success\\/30[data-hover="true"]{
  --tw-shadow-color: hsl(var(--nextui-success) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-warning\\/30[data-hover="true"]{
  --tw-shadow-color: hsl(var(--nextui-warning) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-danger\\/40[data-selected="true"]{
  --tw-shadow-color: hsl(var(--nextui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-foreground\\/40[data-selected="true"]{
  --tw-shadow-color: hsl(var(--nextui-foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-primary\\/40[data-selected="true"]{
  --tw-shadow-color: hsl(var(--nextui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-secondary\\/40[data-selected="true"]{
  --tw-shadow-color: hsl(var(--nextui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-success\\/40[data-selected="true"]{
  --tw-shadow-color: hsl(var(--nextui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-warning\\/40[data-selected="true"]{
  --tw-shadow-color: hsl(var(--nextui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[focus-visible\\=true\\]\\:outline-2[data-focus-visible="true"]{
  outline-width: 2px;
}
.data-\\[focus-visible\\=true\\]\\:outline-offset-2[data-focus-visible="true"]{
  outline-offset: 2px;
}
.data-\\[focus-visible\\=true\\]\\:outline-focus[data-focus-visible="true"]{
  outline-color: hsl(var(--nextui-focus) / var(--nextui-focus-opacity, 1));
}
.data-\\[focus-visible\\]\\:outline-danger-foreground[data-focus-visible]{
  outline-color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:outline-default-foreground[data-focus-visible]{
  outline-color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:outline-primary-foreground[data-focus-visible]{
  outline-color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:outline-secondary-foreground[data-focus-visible]{
  outline-color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:outline-success-foreground[data-focus-visible]{
  outline-color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:outline-warning-foreground[data-focus-visible]{
  outline-color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, 1));
}
.data-\\[menu-open\\=true\\]\\:backdrop-blur-xl[data-menu-open="true"]{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.data-\\[disabled\\=true\\]\\:transition-none[data-disabled="true"]{
  transition-property: none;
}
.data-\\[hover\\=true\\]\\:transition-colors[data-hover="true"]{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.data-\\[moving\\=true\\]\\:transition-transform[data-moving="true"]{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.data-\\[hide-scroll\\=true\\]\\:scrollbar-hide[data-hide-scroll="true"]{
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.data-\\[hide-scroll\\=true\\]\\:scrollbar-hide[data-hide-scroll="true"]::-webkit-scrollbar{
  display: none;
}
.data-\\[top-bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-bottom-scroll="true"]{
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[top-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(0deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-scroll="true"]{
  mask-image: linear-gradient(0deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(180deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-bottom-scroll="true"]{
  mask-image: linear-gradient(180deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[left-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(270deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-scroll="true"]{
  mask-image: linear-gradient(270deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(90deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-right-scroll="true"]{
  mask-image: linear-gradient(90deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[left-right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(to_right\\2c \\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-right-scroll="true"]{
  mask-image: linear-gradient(to right,#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[placement\\=bottom-end\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom-end"]::before{
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom-end\\]\\:before\\:right-3[data-placement="bottom-end"]::before{
  content: var(--tw-content);
  right: 0.75rem;
}
.data-\\[placement\\=bottom-start\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom-start"]::before{
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom-start\\]\\:before\\:left-3[data-placement="bottom-start"]::before{
  content: var(--tw-content);
  left: 0.75rem;
}
.data-\\[placement\\=bottom\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom"]::before{
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom\\]\\:before\\:left-1\\/2[data-placement="bottom"]::before{
  content: var(--tw-content);
  left: 50%;
}
.data-\\[placement\\=left-end\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="left-end"]::before{
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=left-end\\]\\:before\\:bottom-1\\/4[data-placement="left-end"]::before{
  content: var(--tw-content);
  bottom: 25%;
}
.data-\\[placement\\=left-start\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="left-start"]::before{
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=left-start\\]\\:before\\:top-1\\/4[data-placement="left-start"]::before{
  content: var(--tw-content);
  top: 25%;
}
.data-\\[placement\\=left\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement="left"]::before{
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 2px) * -1);
}
.data-\\[placement\\=left\\]\\:before\\:top-1\\/2[data-placement="left"]::before{
  content: var(--tw-content);
  top: 50%;
}
.data-\\[placement\\=right-end\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="right-end"]::before{
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=right-end\\]\\:before\\:bottom-1\\/4[data-placement="right-end"]::before{
  content: var(--tw-content);
  bottom: 25%;
}
.data-\\[placement\\=right-start\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="right-start"]::before{
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=right-start\\]\\:before\\:top-1\\/4[data-placement="right-start"]::before{
  content: var(--tw-content);
  top: 25%;
}
.data-\\[placement\\=right\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement="right"]::before{
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 2px) * -1);
}
.data-\\[placement\\=right\\]\\:before\\:top-1\\/2[data-placement="right"]::before{
  content: var(--tw-content);
  top: 50%;
}
.data-\\[placement\\=top-end\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top-end"]::before{
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top-end\\]\\:before\\:right-3[data-placement="top-end"]::before{
  content: var(--tw-content);
  right: 0.75rem;
}
.data-\\[placement\\=top-start\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top-start"]::before{
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top-start\\]\\:before\\:left-3[data-placement="top-start"]::before{
  content: var(--tw-content);
  left: 0.75rem;
}
.data-\\[placement\\=top\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top"]::before{
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top\\]\\:before\\:left-1\\/2[data-placement="top"]::before{
  content: var(--tw-content);
  left: 50%;
}
.data-\\[loaded\\=true\\]\\:before\\:-z-10[data-loaded="true"]::before{
  content: var(--tw-content);
  z-index: -10;
}
.data-\\[arrow\\=true\\]\\:before\\:block[data-arrow="true"]::before{
  content: var(--tw-content);
  display: block;
}
.data-\\[outside-month\\=true\\]\\:before\\:hidden[data-outside-month="true"]::before{
  content: var(--tw-content);
  display: none;
}
.data-\\[placement\\=bottom\\]\\:before\\:-translate-x-1\\/2[data-placement="bottom"]::before{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=left\\]\\:before\\:-translate-y-1\\/2[data-placement="left"]::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=right\\]\\:before\\:-translate-y-1\\/2[data-placement="right"]::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=top\\]\\:before\\:-translate-x-1\\/2[data-placement="top"]::before{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[loaded\\=true\\]\\:before\\:animate-none[data-loaded="true"]::before{
  content: var(--tw-content);
  animation: none;
}
.data-\\[range-end\\=true\\]\\:before\\:rounded-r-full[data-range-end="true"]::before{
  content: var(--tw-content);
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.data-\\[range-start\\=true\\]\\:before\\:rounded-l-full[data-range-start="true"]::before{
  content: var(--tw-content);
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.data-\\[selection-end\\=true\\]\\:before\\:rounded-r-full[data-selection-end="true"]::before{
  content: var(--tw-content);
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.data-\\[selection-start\\=true\\]\\:before\\:rounded-l-full[data-selection-start="true"]::before{
  content: var(--tw-content);
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-danger-50[data-range-selection="true"][data-selected="true"]::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-foreground\\/10[data-range-selection="true"][data-selected="true"]::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-foreground) / 0.1);
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-primary-50[data-range-selection="true"][data-selected="true"]::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-secondary-50[data-range-selection="true"][data-selected="true"]::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-success-100[data-range-selection="true"][data-selected="true"]::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-100) / var(--nextui-success-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-warning-100[data-range-selection="true"][data-selected="true"]::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-100) / var(--nextui-warning-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[loaded\\=true\\]\\:before\\:opacity-0[data-loaded="true"]::before{
  content: var(--tw-content);
  opacity: 0;
}
.data-\\[selected\\=true\\]\\:before\\:opacity-100[data-selected="true"]::before{
  content: var(--tw-content);
  opacity: 1;
}
.data-\\[active\\=true\\]\\:after\\:w-full[data-active="true"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[focus\\=true\\]\\:after\\:w-full[data-focus="true"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[open\\=true\\]\\:after\\:w-full[data-open="true"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[dragging\\=true\\]\\:after\\:scale-100[data-dragging="true"]::after{
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[dragging\\=true\\]\\:after\\:scale-80[data-dragging="true"]::after{
  content: var(--tw-content);
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[active\\=true\\]\\:after\\:bg-danger-400[data-active="true"]::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-400) / var(--nextui-danger-400-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:after\\:bg-danger[data-selected="true"]::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:after\\:bg-foreground[data-selected="true"]::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:after\\:bg-primary[data-selected="true"]::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:after\\:bg-secondary[data-selected="true"]::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:after\\:bg-success[data-selected="true"]::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:after\\:bg-warning[data-selected="true"]::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[loaded\\=true\\]\\:after\\:opacity-0[data-loaded="true"]::after{
  content: var(--tw-content);
  opacity: 0;
}
.data-\\[selected\\=true\\]\\:after\\:opacity-100[data-selected="true"]::after{
  content: var(--tw-content);
  opacity: 1;
}
.data-\\[selectable\\=true\\]\\:focus\\:border-danger:focus[data-selectable="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-default:focus[data-selectable="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-border-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-primary:focus[data-selectable="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-secondary:focus[data-selectable="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-success:focus[data-selectable="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-warning:focus[data-selectable="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.data-\\[invalid\\=true\\]\\:focus\\:bg-danger-400\\/50:focus[data-invalid="true"]{
  background-color: hsl(var(--nextui-danger-400) / 0.5);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-danger:focus[data-selectable="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-danger\\/20:focus[data-selectable="true"]{
  background-color: hsl(var(--nextui-danger) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-default:focus[data-selectable="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-default-100:focus[data-selectable="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-default\\/40:focus[data-selectable="true"]{
  background-color: hsl(var(--nextui-default) / 0.4);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-primary:focus[data-selectable="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-primary\\/20:focus[data-selectable="true"]{
  background-color: hsl(var(--nextui-primary) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-secondary:focus[data-selectable="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-secondary\\/20:focus[data-selectable="true"]{
  background-color: hsl(var(--nextui-secondary) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-success:focus[data-selectable="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-success\\/20:focus[data-selectable="true"]{
  background-color: hsl(var(--nextui-success) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-warning:focus[data-selectable="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-warning\\/20:focus[data-selectable="true"]{
  background-color: hsl(var(--nextui-warning) / 0.2);
}
.data-\\[editable\\=true\\]\\:focus\\:text-danger:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:text-default-foreground:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:text-primary:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:text-secondary:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:text-success:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:text-success-600:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-600) / var(--nextui-success-600-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:text-warning:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:text-warning-600:focus[data-editable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-600) / var(--nextui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:focus\\:text-danger:focus[data-editable="true"][data-invalid="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-danger:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-danger-foreground:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-default-500:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-500) / var(--nextui-default-500-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-default-foreground:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-primary:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-primary-foreground:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-secondary:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-secondary-foreground:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-success:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-success-foreground:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-warning:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-warning-foreground:focus[data-selectable="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-danger\\/30:focus[data-selectable="true"]{
  --tw-shadow-color: hsl(var(--nextui-danger) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-default\\/50:focus[data-selectable="true"]{
  --tw-shadow-color: hsl(var(--nextui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-primary\\/30:focus[data-selectable="true"]{
  --tw-shadow-color: hsl(var(--nextui-primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-secondary\\/30:focus[data-selectable="true"]{
  --tw-shadow-color: hsl(var(--nextui-secondary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-success\\/30:focus[data-selectable="true"]{
  --tw-shadow-color: hsl(var(--nextui-success) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-warning\\/30:focus[data-selectable="true"]{
  --tw-shadow-color: hsl(var(--nextui-warning) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:pointer-events-auto{
  pointer-events: auto;
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:pointer-events-auto{
  pointer-events: auto;
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:start-0{
  inset-inline-start: 0px;
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:start-0{
  inset-inline-start: 0px;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:z-10{
  z-index: 10;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-4{
  margin-inline-start: 1rem;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-5{
  margin-inline-start: 1.25rem;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-6{
  margin-inline-start: 1.5rem;
}
.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-3{
  margin-left: 0.75rem;
}
.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-4{
  margin-left: 1rem;
}
.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-5{
  margin-left: 1.25rem;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:block{
  display: block;
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:block{
  display: block;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:flex{
  display: flex;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:hidden{
  display: none;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-5{
  width: 1.25rem;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-6{
  width: 1.5rem;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-7{
  width: 1.75rem;
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_20px\\)\\]{
  --tw-translate-y: calc(calc(100% + var(--nextui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_24px\\)\\]{
  --tw-translate-y: calc(calc(100% + var(--nextui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_\\+_16px\\)\\]{
  --tw-translate-y: calc(calc(100% + var(--nextui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_3\\.5px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_4px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px_-_theme\\(borderWidth\\.medium\\)\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 6px - var(--nextui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 8px - var(--nextui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_5px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-tiny) / 2 - 8px - var(--nextui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_20px\\)\\]{
  --tw-translate-y: calc(calc(100% + var(--nextui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_24px\\)\\]{
  --tw-translate-y: calc(calc(100% + var(--nextui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_\\+_16px\\)\\]{
  --tw-translate-y: calc(calc(100% + var(--nextui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_3\\.5px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_4px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px_-_theme\\(borderWidth\\.medium\\)\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 6px - var(--nextui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-small) / 2 - 8px - var(--nextui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_5px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\]{
  --tw-translate-y: calc(calc(50% + var(--nextui-font-size-tiny) / 2 - 8px - var(--nextui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:translate-x-3{
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:scale-50{
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:scale-85{
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:scale-85{
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/tr[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\/tr\\:cursor-not-allowed{
  cursor: not-allowed;
}
.group[data-has-multiple-months="true"] .group-data-\\[has-multiple-months\\=true\\]\\:flex-row{
  flex-direction: row;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:items-start{
  align-items: flex-start;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:items-end{
  align-items: flex-end;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:\\!border-danger{
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity))) !important;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-danger{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-default-foreground{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-border-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:border-danger{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-danger{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-default-500{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-500) / var(--nextui-default-500-opacity, var(--tw-border-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-border-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-border-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-border-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-border-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:\\!bg-danger-50{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity))) !important;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-danger-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-default-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-default-200{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-primary-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-secondary-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-success-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-warning-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.group[data-hover-unselected="true"] .group-data-\\[hover-unselected\\=true\\]\\:bg-default-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:bg-danger-50{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-danger{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-default-400{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-400) / var(--nextui-default-400-opacity, var(--tw-bg-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-primary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-bg-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-secondary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-bg-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-success{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-warning{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-2{
  padding-top: 0.5rem;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-3{
  padding-top: 0.75rem;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-4{
  padding-top: 1rem;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:pt-4{
  padding-top: 1rem;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:pt-5{
  padding-top: 1.25rem;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:font-semibold{
  font-weight: 600;
}
.group\\/tr[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\/tr\\:text-foreground-300{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground-300) / var(--nextui-foreground-300-opacity, var(--tw-text-opacity)));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:text-default-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-600) / var(--nextui-default-600-opacity, var(--tw-text-opacity)));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:text-default-600{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-600) / var(--nextui-default-600-opacity, var(--tw-text-opacity)));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:text-default-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:text-danger{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-danger{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-danger-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-default-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-default-foreground) / var(--nextui-default-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-foreground) / var(--nextui-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-primary{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-primary-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary-foreground) / var(--nextui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-secondary{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary) / var(--nextui-secondary-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-secondary-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-secondary-foreground) / var(--nextui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-success{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-success-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-warning{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-warning-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:opacity-0{
  opacity: 0;
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:opacity-100{
  opacity: 1;
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:opacity-70{
  opacity: 0.7;
}
.group\\/th[data-hover="true"] .group-data-\\[hover\\=true\\]\\/th\\:opacity-100{
  opacity: 1;
}
.group[data-loaded="true"] .group-data-\\[loaded\\=true\\]\\:opacity-100{
  opacity: 1;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:opacity-70{
  opacity: 0.7;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-0{
  opacity: 0;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-100{
  opacity: 1;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-60{
  opacity: 0.6;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--nextui-focus) / var(--nextui-focus-opacity, var(--tw-ring-opacity)));
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-background{
  --tw-ring-offset-color: hsl(var(--nextui-background) / var(--nextui-background-opacity, 1));
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:-z-10::before{
  content: var(--tw-content);
  z-index: -10;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:before\\:w-full::before{
  content: var(--tw-content);
  width: 100%;
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:before\\:translate-y-px::before{
  content: var(--tw-content);
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:before\\:rotate-45::before{
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/tr[data-middle="true"] .group-data-\\[middle\\=true\\]\\/tr\\:before\\:rounded-none::before{
  content: var(--tw-content);
  border-radius: 0px;
}
.group[data-hover="true"] .group-data-\\[hover\\=true\\]\\:before\\:bg-default-100::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:bg-default-100::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:opacity-100::before{
  content: var(--tw-content);
  opacity: 1;
}
.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:ml-0\\.5::after{
  content: var(--tw-content);
  margin-left: 0.125rem;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:after\\:w-full::after{
  content: var(--tw-content);
  width: 100%;
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:after\\:translate-y-0::after{
  content: var(--tw-content);
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:after\\:-rotate-45::after{
  content: var(--tw-content);
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:after\\:scale-100::after{
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:after\\:bg-danger::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:text-danger::after{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-text-opacity)));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:after\\:opacity-100::after{
  content: var(--tw-content);
  opacity: 1;
}
.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:content-\\[\\'\\*\\'\\]::after{
  --tw-content: '*';
  content: var(--tw-content);
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:hover\\:border-danger:hover{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:hover\\:bg-danger-100:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-bg-opacity)));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:border-danger:hover:focus-within{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-border-opacity)));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:bg-danger-50:hover:focus-within{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.group\\/tr[aria-selected="false"][data-hover="true"] .group-aria-\\[selected\\=false\\]\\/tr\\:group-data-\\[hover\\=true\\]\\/tr\\:before\\:bg-default-100::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.group\\/tr[aria-selected="false"][data-hover="true"] .group-aria-\\[selected\\=false\\]\\/tr\\:group-data-\\[hover\\=true\\]\\/tr\\:before\\:opacity-70::before{
  content: var(--tw-content);
  opacity: 0.7;
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-danger\\/20[data-selected="true"]::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-danger) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-default\\/60[data-selected="true"]::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-default) / 0.6);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-primary\\/20[data-selected="true"]::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-primary) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-secondary\\/20[data-selected="true"]::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-secondary) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-success\\/20[data-selected="true"]::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-success) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-warning\\/20[data-selected="true"]::before{
  content: var(--tw-content);
  background-color: hsl(var(--nextui-warning) / 0.2);
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:pointer-events-auto{
  pointer-events: auto;
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:block{
  display: block;
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:opacity-70{
  opacity: 0.7;
}
@media (prefers-reduced-motion: reduce){
  .motion-reduce\\:scale-100{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .motion-reduce\\:transition-none{
    transition-property: none;
  }
  .motion-reduce\\:after\\:transition-none::after{
    content: var(--tw-content);
    transition-property: none;
  }
}
.dark\\:border-danger-100:is(.dark *){
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-border-opacity)));
}
.dark\\:border-default-200:is(.dark *){
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-border-opacity)));
}
.dark\\:border-primary-100:is(.dark *){
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-primary-100) / var(--nextui-primary-100-opacity, var(--tw-border-opacity)));
}
.dark\\:border-success-100:is(.dark *){
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-success-100) / var(--nextui-success-100-opacity, var(--tw-border-opacity)));
}
.dark\\:border-warning-100:is(.dark *){
  --tw-border-opacity: 1;
  border-color: hsl(var(--nextui-warning-100) / var(--nextui-warning-100-opacity, var(--tw-border-opacity)));
}
.dark\\:bg-background:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-background) / var(--nextui-background-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-background\\/20:is(.dark *){
  background-color: hsl(var(--nextui-background) / 0.2);
}
.dark\\:bg-content2:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content2) / var(--nextui-content2-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-danger-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-100) / var(--nextui-danger-100-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-danger-50:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-danger-50\\/50:is(.dark *){
  background-color: hsl(var(--nextui-danger-50) / 0.5);
}
.dark\\:bg-default:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default) / var(--nextui-default-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-default-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-default-50\\/50:is(.dark *){
  background-color: hsl(var(--nextui-default-50) / 0.5);
}
.dark\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-100) / var(--nextui-primary-100-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-primary-50:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-primary-50) / var(--nextui-primary-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-primary-50\\/50:is(.dark *){
  background-color: hsl(var(--nextui-primary-50) / 0.5);
}
.dark\\:bg-secondary-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-100) / var(--nextui-secondary-100-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-secondary-50:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-secondary-50) / var(--nextui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-secondary-50\\/50:is(.dark *){
  background-color: hsl(var(--nextui-secondary-50) / 0.5);
}
.dark\\:bg-success-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-100) / var(--nextui-success-100-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-success-50:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-success-50\\/50:is(.dark *){
  background-color: hsl(var(--nextui-success-50) / 0.5);
}
.dark\\:bg-transparent:is(.dark *){
  background-color: transparent;
}
.dark\\:bg-warning-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-100) / var(--nextui-warning-100-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-warning-50:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:bg-warning-50\\/50:is(.dark *){
  background-color: hsl(var(--nextui-warning-50) / 0.5);
}
.dark\\:text-danger-500:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-500) / var(--nextui-danger-500-opacity, var(--tw-text-opacity)));
}
.dark\\:text-success:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.dark\\:text-warning:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.dark\\:placeholder\\:text-danger-500:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-500) / var(--nextui-danger-500-opacity, var(--tw-text-opacity)));
}
.dark\\:placeholder\\:text-success:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.dark\\:placeholder\\:text-warning:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.dark\\:before\\:via-default-700\\/10:is(.dark *)::before{
  content: var(--tw-content);
  --tw-gradient-to: hsl(var(--nextui-default-700) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--nextui-default-700) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:after\\:bg-content2:is(.dark *)::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content2) / var(--nextui-content2-opacity, var(--tw-bg-opacity)));
}
.dark\\:focus\\:bg-danger-400\\/20:focus:is(.dark *){
  background-color: hsl(var(--nextui-danger-400) / 0.2);
}
.dark\\:focus\\:bg-success-400\\/20:focus:is(.dark *){
  background-color: hsl(var(--nextui-success-400) / 0.2);
}
.dark\\:focus\\:bg-warning-400\\/20:focus:is(.dark *){
  background-color: hsl(var(--nextui-warning-400) / 0.2);
}
.dark\\:data-\\[hover\\=true\\]\\:bg-content2[data-hover="true"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-content2) / var(--nextui-content2-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[hover\\=true\\]\\:bg-danger-50[data-hover="true"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger-50) / var(--nextui-danger-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[hover\\=true\\]\\:bg-success-50[data-hover="true"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[hover\\=true\\]\\:bg-warning-50[data-hover="true"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"][data-selected="true"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-danger) / var(--nextui-danger-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-success[data-hover="true"][data-selected="true"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"][data-selected="true"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[hover\\=true\\]\\:text-danger-500[data-hover="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-500) / var(--nextui-danger-500-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[hover\\=true\\]\\:text-success-500[data-hover="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-500) / var(--nextui-success-500-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[hover\\=true\\]\\:text-warning-500[data-hover="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-500) / var(--nextui-warning-500-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"][data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-foreground) / var(--nextui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"][data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"][data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning-foreground) / var(--nextui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-500[data-range-selection="true"][data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-500) / var(--nextui-success-500-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success-foreground) / var(--nextui-success-foreground-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:text-danger-500[data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-danger-500) / var(--nextui-danger-500-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:text-success[data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-success) / var(--nextui-success-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:text-warning[data-selected="true"]:is(.dark *){
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-warning) / var(--nextui-warning-opacity, var(--tw-text-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-success-50[data-range-selection="true"][data-selected="true"]:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-success-50) / var(--nextui-success-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-warning-50[data-range-selection="true"][data-selected="true"]:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-warning-50) / var(--nextui-warning-50-opacity, var(--tw-bg-opacity)));
}
.dark\\:data-\\[invalid\\=true\\]\\:focus\\:bg-danger-400\\/20:focus[data-invalid="true"]:is(.dark *){
  background-color: hsl(var(--nextui-danger-400) / 0.2);
}
@media (min-width: 640px){
  .sm\\:m-0{
    margin: 0px;
  }
  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .sm\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .sm\\:my-0{
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .sm\\:my-16{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:h-80{
    height: 20rem;
  }
  .sm\\:w-1\\/4{
    width: 25%;
  }
  .sm\\:w-2\\/5{
    width: 40%;
  }
  .sm\\:w-80{
    width: 20rem;
  }
  .sm\\:w-\\[330px\\]{
    width: 330px;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-end{
    align-items: flex-end;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-between{
    justify-content: space-between;
  }
  .sm\\:gap-5{
    gap: 1.25rem;
  }
  .sm\\:p-5{
    padding: 1.25rem;
  }
  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sm\\:pb-2{
    padding-bottom: 0.5rem;
  }
  .sm\\:pr-3{
    padding-right: 0.75rem;
  }
  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:\\[--scale-enter\\:100\\%\\]{
    --scale-enter: 100%;
  }
  .sm\\:\\[--scale-exit\\:103\\%\\]{
    --scale-exit: 103%;
  }
  .sm\\:\\[--slide-enter\\:0px\\]{
    --slide-enter: 0px;
  }
  .sm\\:\\[--slide-exit\\:0px\\]{
    --slide-exit: 0px;
  }
  .sm\\:data-\\[visible\\=true\\]\\:pointer-events-none[data-visible="true"]{
    pointer-events: none;
  }
  .sm\\:data-\\[visible\\=true\\]\\:opacity-0[data-visible="true"]{
    opacity: 0;
  }
  .group[data-hover="true"] .sm\\:group-data-\\[hover\\=true\\]\\:data-\\[visible\\=true\\]\\:pointer-events-auto[data-visible="true"]{
    pointer-events: auto;
  }
  .group[data-hover="true"] .sm\\:group-data-\\[hover\\=true\\]\\:data-\\[visible\\=true\\]\\:opacity-100[data-visible="true"]{
    opacity: 1;
  }
}
@media (min-width: 768px){
  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .md\\:row-span-2{
    grid-row: span 2 / span 2;
  }
  .md\\:mb-0{
    margin-bottom: 0px;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-1\\/3{
    width: 33.333333%;
  }
  .md\\:w-1\\/4{
    width: 25%;
  }
  .md\\:w-2\\/3{
    width: 66.666667%;
  }
  .md\\:w-2\\/5{
    width: 40%;
  }
  .md\\:w-3\\/5{
    width: 60%;
  }
  .md\\:w-\\[204px\\]{
    width: 204px;
  }
  .md\\:w-full{
    width: 100%;
  }
  .md\\:max-w-\\[200px\\]{
    max-width: 200px;
  }
  .md\\:max-w-md{
    max-width: 28rem;
  }
  .md\\:max-w-sm{
    max-width: 24rem;
  }
  .md\\:flex-none{
    flex: none;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:grid-cols-\\[1fr_auto\\]{
    grid-template-columns: 1fr auto;
  }
  .md\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:flex-row-reverse{
    flex-direction: row-reverse;
  }
  .md\\:items-start{
    align-items: flex-start;
  }
  .md\\:items-end{
    align-items: flex-end;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-end{
    justify-content: flex-end;
  }
  .md\\:justify-between{
    justify-content: space-between;
  }
  .md\\:gap-8{
    gap: 2rem;
  }
  .md\\:p-24{
    padding: 6rem;
  }
  .md\\:p-6{
    padding: 1.5rem;
  }
  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .md\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .md\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .md\\:text-start{
    text-align: start;
  }
  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .md\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }
  .md\\:text-\\[34px\\]{
    font-size: 34px;
  }
  .md\\:text-\\[40px\\]{
    font-size: 40px;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .md\\:leading-\\[52px\\]{
    line-height: 52px;
  }
}
@media (min-width: 1024px){
  .lg\\:visible{
    visibility: visible;
  }
  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .lg\\:m-0{
    margin: 0px;
  }
  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .lg\\:ml-sidebar{
    margin-left: 264px;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:size-14{
    width: 3.5rem;
    height: 3.5rem;
  }
  .lg\\:h-\\[408px\\]{
    height: 408px;
  }
  .lg\\:min-h-\\[100px\\]{
    min-height: 100px;
  }
  .lg\\:w-1\\/2{
    width: 50%;
  }
  .lg\\:w-1\\/3{
    width: 33.333333%;
  }
  .lg\\:w-1\\/4{
    width: 25%;
  }
  .lg\\:w-2\\/3{
    width: 66.666667%;
  }
  .lg\\:w-2\\/6{
    width: 33.333333%;
  }
  .lg\\:w-64{
    width: 16rem;
  }
  .lg\\:w-\\[122px\\]{
    width: 122px;
  }
  .lg\\:max-w-screen-lg{
    max-width: 1024px;
  }
  .lg\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-\\[1fr_440px\\]{
    grid-template-columns: 1fr 440px;
  }
  .lg\\:grid-cols-\\[280px_1fr\\]{
    grid-template-columns: 280px 1fr;
  }
  .lg\\:grid-cols-\\[430px_1fr\\]{
    grid-template-columns: 430px 1fr;
  }
  .lg\\:grid-cols-\\[450px_1fr_334px\\]{
    grid-template-columns: 450px 1fr 334px;
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-col{
    flex-direction: column;
  }
  .lg\\:items-end{
    align-items: flex-end;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-start{
    justify-content: flex-start;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:gap-0{
    gap: 0px;
  }
  .lg\\:gap-16{
    gap: 4rem;
  }
  .lg\\:gap-20{
    gap: 5rem;
  }
  .lg\\:gap-\\[72px\\]{
    gap: 72px;
  }
  .lg\\:gap-x-8{
    column-gap: 2rem;
  }
  .lg\\:rounded-none{
    border-radius: 0px;
  }
  .lg\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
  .lg\\:p-11{
    padding: 2.75rem;
  }
  .lg\\:p-16{
    padding: 4rem;
  }
  .lg\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .lg\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .lg\\:px-\\[120px\\]{
    padding-left: 120px;
    padding-right: 120px;
  }
  .lg\\:px-\\[72px\\]{
    padding-left: 72px;
    padding-right: 72px;
  }
  .lg\\:pb-14{
    padding-bottom: 3.5rem;
  }
  .lg\\:pb-3{
    padding-bottom: 0.75rem;
  }
  .lg\\:pl-sidebar{
    padding-left: 264px;
  }
  .lg\\:pt-9{
    padding-top: 2.25rem;
  }
  .lg\\:pt-\\[60px\\]{
    padding-top: 60px;
  }
  .lg\\:text-start{
    text-align: start;
  }
  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .lg\\:text-\\[21px\\]{
    font-size: 21px;
  }
  .lg\\:text-\\[60px\\]{
    font-size: 60px;
  }
  .lg\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .lg\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .lg\\:tracking-\\[-2\\.6px\\]{
    letter-spacing: -2.6px;
  }
  .lg\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 1280px){
  .xl\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .xl\\:w-\\[320px\\]{
    width: 320px;
  }
  .xl\\:w-auto{
    width: auto;
  }
  .xl\\:flex-none{
    flex: none;
  }
  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:flex-row{
    flex-direction: row;
  }
  .xl\\:items-center{
    align-items: center;
  }
  .xl\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .xl\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
.rtl\\:left-2:where([dir="rtl"], [dir="rtl"] *){
  left: 0.5rem;
}
.rtl\\:right-auto:where([dir="rtl"], [dir="rtl"] *){
  right: auto;
}
.rtl\\:origin-top-right:where([dir="rtl"], [dir="rtl"] *){
  transform-origin: top right;
}
.rtl\\:-rotate-180:where([dir="rtl"], [dir="rtl"] *){
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *){
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:flex-row-reverse:where([dir="rtl"], [dir="rtl"] *){
  flex-direction: row-reverse;
}
.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}
.rtl\\:data-\\[focus-visible\\=true\\]\\:translate-x-3[data-focus-visible="true"]:where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:data-\\[hover\\=true\\]\\:translate-x-3[data-hover="true"]:where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:data-\\[open\\=true\\]\\:-rotate-90[data-open="true"]:where([dir="rtl"], [dir="rtl"] *){
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\+\\.border-medium\\.border-danger\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-danger{
  margin-inline-start: calc(var(--nextui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-default\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-default{
  margin-inline-start: calc(var(--nextui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-primary\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-primary{
  margin-inline-start: calc(var(--nextui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-secondary\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-secondary{
  margin-inline-start: calc(var(--nextui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-success\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-success{
  margin-inline-start: calc(var(--nextui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-warning\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.border-medium.border-warning{
  margin-inline-start: calc(var(--nextui-border-width-medium) * -1);
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{
  display: none;
}
.\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\]\\:rounded-none:not(:first-child):not(:last-child){
  border-radius: 0px;
}
.\\[\\&\\:not\\(\\:first-child\\)\\]\\:-ml-1:not(:first-child){
  margin-left: -0.25rem;
}
.\\[\\&\\:not\\(\\:first-of-type\\)\\:not\\(\\:last-of-type\\)\\]\\:rounded-none:not(:first-of-type):not(:last-of-type){
  border-radius: 0px;
}
.\\[\\&\\:not\\(\\:first-of-type\\)\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.2\\)\\*-1\\)\\]:not(:first-of-type){
  margin-inline-start: calc(2px * -1);
}
.\\[\\&\\>\\*\\]\\:relative>*{
  position: relative;
}
.\\[\\&\\>svg\\]\\:max-w-\\[theme\\(spacing\\.8\\)\\]>svg{
  max-width: 2rem;
}
.\\[\\&\\>tr\\]\\:first\\:rounded-lg:first-child>tr{
  border-radius: 0.5rem;
}
.\\[\\&\\>tr\\]\\:first\\:shadow-small:first-child>tr{
  --tw-shadow: var(--nextui-box-shadow-small);
  --tw-shadow-colored: var(--nextui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\[\\&\\[data-hover\\=true\\]\\:not\\(\\[data-active\\=true\\]\\)\\]\\:bg-default-100[data-hover=true]:not([data-active=true]){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-100) / var(--nextui-default-100-opacity, var(--tw-bg-opacity)));
}
.\\[\\&\\[data-hover\\=true\\]\\:not\\(\\[data-active\\=true\\]\\)\\]\\:bg-default-200[data-hover=true]:not([data-active=true]){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nextui-default-200) / var(--nextui-default-200-opacity, var(--tw-bg-opacity)));
}
.\\[\\&_\\.chevron-icon\\]\\:flex-none .chevron-icon{
  flex: none;
}
.\\[\\&_\\.chevron-icon\\]\\:rotate-180 .chevron-icon{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\.chevron-icon\\]\\:transition-transform .chevron-icon{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.\\[\\&_a\\]\\:text-pb-aksen a{
  --tw-text-opacity: 1;
  color: rgb(37 102 77 / var(--tw-text-opacity, 1));
}
.\\[\\&_a\\]\\:text-primary a{
  --tw-text-opacity: 1;
  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)));
}
.\\[\\&_a\\]\\:underline a{
  text-decoration-line: underline;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,uGAAuG;AAEvG;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd,kEAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,yDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;EAAA,oCAAc;EAAd;AAAc;AAAd;;;;qEAAc;AAAd;IAAA,6BAAc;IAAd,wBAAc;IAAd,2BAAc;IAAd,qBAAc;EAAA;AAAd;IAAA,gCAAc;EAAA;AAAd;IAAA,6BAAc;EAAA;AAAd,2EAAc;AAAd;;iFAAc;AAAd;IAAA,+BAAc;IAAd,mBAAc;IAAd,0BAAc;EAAA;AAAd;oEAAc;AAAd;IAAA,wBAAc;EAAA;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAsDlB,+DAA+D;AAC/D;IACE,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB,EAAE,wCAAwC;IAC1D,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;EACxB;AACA;IACE,OAAO;EACT;AAEA,uEAAuE;AASvE,QAAQ,gCAAgC,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,2BAA2B,EAAE;AAQjH,yDAAyD;AAGzD;;;;;;;kDAOgD;AAChD;IACE,yCAAyC;IACzC,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;EACrB;AAEA;;;;;;;yBAOuB;AACvB;IACE,eAAe;EACjB;AAEA;;;;;;;;;;;;;;4EAc0E;AAC1E;;IAEE,gBAAgB;EAClB;AACA;;IAEE,eAAe,EAAE,8BAA8B;EACjD;AAEA;;;;;;;wBAOsB;AACtB;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;AAEA;yEACuE;AAMvE;oDACkD;AAMlD;oEACkE;AAClE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,4BAA4B;IAC5B,sFAAsF;IACtF,mCAAmC;EACrC;AA9LF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,UAAmB;IAAnB;EAAmB;EAAnB;IAAA,aAAmB;IAAnB,2BAAmB;IAAnB,kCAAmB;IAAnB;EAAmB;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,YAAmB;IAAnB;EAAmB;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sCAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,yBAAmB;EAAnB,4BAAmB;EAAnB,iCAAmB;EAAnB,uCAAmB;EAAnB,uCAAmB;EAAnB,mCAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,sCAAmB;EAAnB,uCAAmB;EAAnB,0CAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,gDAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,uCAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,qDAAmB;EAAnB,0CAAmB;EAAnB,oDAAmB;EAAnB,oDAAmB;EAAnB,oDAAmB;EAAnB,uCAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uDAAmB;EAAnB,yCAAmB;EAAnB,wDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,wDAAmB;EAAnB,4CAAmB;EAAnB,uDAAmB;EAAnB,sDAAmB;EAAnB,4CAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,mCAAmB;EAAnB,yCAAmB;EAAnB,uCAAmB;EAAnB,qCAAmB;EAAnB,0CAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,uCAAmB;EAAnB,qDAAmB;EAAnB,sCAAmB;EAAnB,kDAAmB;EAAnB,iDAAmB;EAAnB,mDAAmB;EAAnB,mDAAmB;EAAnB,sDAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,sDAAmB;EAAnB,mDAAmB;EAAnB,sCAAmB;EAAnB,iDAAmB;EAAnB,oDAAmB;EAAnB,oDAAmB;EAAnB,oDAAmB;EAAnB,mDAAmB;EAAnB,oDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,oDAAmB;EAAnB,oDAAmB;EAAnB,qCAAmB;EAAnB,gDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,mCAAmB;EAAnB,gCAAmB;EAAnB,kFAAmB;EAAnB,oFAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4BAAmB;EAAnB,qCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,oCAAmB;EAAnB,qCAAmB;EAAnB,8CAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,8BAAmB;EAAnB,gCAAmB;EAAnB,yCAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,mCAAmB;EAAnB,2CAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,kCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,iCAAmB;EAAnB,sCAAmB;EAAnB,kCAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,oDAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,sDAAmB;EAAnB,oCAAmB;EAAnB,kDAAmB;EAAnB,kDAAmB;EAAnB,mDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oCAAmB;EAAnB,gDAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,qDAAmB;EAAnB,mCAAmB;EAAnB,wCAAmB;EAAnB,iDAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,iCAAmB;EAAnB,gCAAmB;EAAnB,8IAAmB;EAAnB,iJAAmB;EAAnB,iJAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wGAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+HAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAyCnB;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AA+IA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oGAAoG;EACpG,+BAA+B;EAC/B,mDAAmD;EACnD,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;+EAc+E;AAC/E;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;AA9QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,qBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,qBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,uBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;IAAA,0BA+QA;IA/QA;EA+QA;AAAA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,gEA+QA;EA/QA,+DA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,iFA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,2CA+QA;EA/QA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,+FA+QA;EA/QA,wDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,8BA+QA;EA/QA,wDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,gBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,0BA+QA;EA/QA,gCA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,yBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,gBA+QA;EA/QA,gBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,yCA+QA;EA/QA,uDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,2CA+QA;EA/QA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,wBA+QA;EA/QA,wDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,8BA+QA;EA/QA,wDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,gBA+QA;EA/QA;AA+QA;AA/QA;EAAA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,+BA+QA;EA/QA,gCA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,0BA+QA;EA/QA,gCA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,2BA+QA;EA/QA,gCA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,uCA+QA;EA/QA,gCA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,iCA+QA;EA/QA;AA+QA;AA/QA;EAAA,qDA+QA;EA/QA;AA+QA;AA/QA;EAAA,iCA+QA;EA/QA;AA+QA;AA/QA;EAAA,sDA+QA;EA/QA;AA+QA;AA/QA;EAAA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA,qDA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,iCA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,oDA+QA;EA/QA;AA+QA;AA/QA;EAAA,4BA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,4BA+QA;EA/QA;AA+QA;AA/QA;EAAA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,2GA+QA;EA/QA,yGA+QA;EA/QA;AA+QA;AA/QA;EAAA,2GA+QA;EA/QA,yGA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,iBA+QA;EA/QA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,qEA+QA;EA/QA,wFA+QA;EA/QA;AA+QA;AA/QA;EAAA,gCA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,0CA+QA;EA/QA,uDA+QA;EA/QA;AA+QA;AA/QA;EAAA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,2GA+QA;EA/QA,yGA+QA;EA/QA;AA+QA;AA/QA;EAAA,2GA+QA;EA/QA,yGA+QA;EA/QA;AA+QA;AA/QA;EAAA,2GA+QA;EA/QA,yGA+QA;EA/QA;AA+QA;AA/QA;EAAA,2GA+QA;EA/QA,yGA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,qBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA,iBA+QA;EA/QA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,6EA+QA;EA/QA,iGA+QA;EA/QA;AA+QA;AA/QA;EAAA,+EA+QA;EA/QA,mGA+QA;EA/QA;AA+QA;AA/QA;EAAA,6EA+QA;EA/QA,iGA+QA;EA/QA;AA+QA;AA/QA;EAAA,6EA+QA;EA/QA,iGA+QA;EA/QA;AA+QA;AA/QA;EAAA,6EA+QA;EA/QA,iGA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA,kDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,qDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,kDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,qDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,kDA+QA;EA/QA;AA+QA;AA/QA;EAAA,sDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,qDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,+FA+QA;EA/QA,wDA+QA;EA/QA;AA+QA;AA/QA;EAAA,8BA+QA;EA/QA,wDA+QA;EA/QA;AA+QA;AA/QA;EAAA,wBA+QA;EA/QA,qBA+QA;AAAA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,+BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,8BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,iBA+QA;EA/QA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,qDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kFA+QA;EA/QA;AA+QA;AA/QA;EAAA,kFA+QA;EA/QA;AA+QA;AA/QA;EAAA,iFA+QA;EA/QA;AA+QA;AA/QA;EAAA,kFA+QA;EA/QA;AA+QA;AA/QA;EAAA,gFA+QA;EA/QA;AA+QA;AA/QA;EAAA,gFA+QA;EA/QA;AA+QA;AA/QA;EAAA,oHA+QA;EA/QA;AA+QA;AA/QA;EAAA,gFA+QA;EA/QA;AA+QA;AA/QA;EAAA,oHA+QA;EA/QA;AA+QA;AA/QA;EAAA,+EA+QA;EA/QA;AA+QA;AA/QA;EAAA,+EA+QA;EA/QA;AA+QA;AA/QA;EAAA,mHA+QA;EA/QA;AA+QA;AA/QA;EAAA,kFA+QA;EA/QA;AA+QA;AA/QA;EAAA,kFA+QA;EA/QA;AA+QA;AA/QA;EAAA,iFA+QA;EA/QA;AA+QA;AA/QA;EAAA,kFA+QA;EA/QA;AA+QA;AA/QA;EAAA,gFA+QA;EA/QA;AA+QA;AA/QA;EAAA,gFA+QA;EA/QA;AA+QA;AA/QA;EAAA,oHA+QA;EA/QA;AA+QA;AA/QA;EAAA,gFA+QA;EA/QA;AA+QA;AA/QA;EAAA,oHA+QA;EA/QA;AA+QA;AA/QA;EAAA,+EA+QA;EA/QA;AA+QA;AA/QA;EAAA,+EA+QA;EA/QA;AA+QA;AA/QA;EAAA,mHA+QA;EA/QA;AA+QA;AA/QA;EAAA,yBA+QA;EA/QA;AA+QA;AA/QA;EAAA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA,gBA+QA;EA/QA,gBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA,iBA+QA;EA/QA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,iCA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,6BA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,2GA+QA;EA/QA,yGA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,qBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,qBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,iBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,eA+QA;EA/QA,eA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;IAAA,eA+QA;IA/QA,eA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,0BA+QA;IA/QA;EA+QA;AAAA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,sBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,oFA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,0BA+QA;EA/QA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;IAAA;EA+QA;EA/QA;IAAA,gBA+QA;IA/QA;EA+QA;EA/QA;IAAA,mBA+QA;IA/QA;EA+QA;EA/QA;IAAA,eA+QA;IA/QA;EA+QA;EA/QA;IAAA,gBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;AAAA;AA/QA;EAAA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,oBA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA,qBA+QA;IA/QA;EA+QA;EA/QA;IAAA,qBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,iBA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA,eA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA,iBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,mBA+QA;IA/QA;EA+QA;EA/QA;IAAA,mBA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;AAAA;AA/QA;EAAA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,gBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,aA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,qBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA,mBA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,mBA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,mBA+QA;IA/QA;EA+QA;EA/QA;IAAA,kBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,sBA+QA;IA/QA,8BA+QA;IA/QA;EA+QA;AAAA;AA/QA;EAAA;IAAA,gBA+QA;IA/QA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA;EA+QA;EA/QA;IAAA,iBA+QA;IA/QA;EA+QA;EA/QA;IAAA,gBA+QA;IA/QA;EA+QA;AAAA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,yBA+QA;EA/QA;AA+QA;AA/QA;EAAA,yBA+QA;EA/QA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,2CA+QA;EA/QA,mDA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA,kBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA;AA/QA;EAAA,mBA+QA;EA/QA;AA+QA;AA/QA;EAAA,8BA+QA;EA/QA,wDA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA,oBA+QA;EA/QA;AA+QA;AA/QA;EAAA;AA+QA","sourcesContent":["/* Font Design System KLH/BPLH v2.1 — Plus Jakarta Sans (judul) · Inter (isi) · JetBrains Mono (data) */\n@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  /* — FASE 2 · Tipografi —\n     Hanya JENIS HURUF yang diatur global. Ukuran heading sengaja TIDAK diset:\n     ada 48 heading polos (<h3> tanpa class) yang dipakai sebagai baris label di\n     dalam popup peta, dan menaikkannya ke skala DS akan merusak popup tersebut.\n     Skala tipe DS tersedia sebagai kelas .t-* di layer components. */\n  body {\n    font-family: var(--font-body);\n    font-size: var(--t-body);\n    line-height: var(--lh-body);\n    color: var(--ink-900);\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    font-family: var(--font-display);\n  }\n\n  code, kbd, samp, pre {\n    font-family: var(--font-mono);\n  }\n\n  /* — FASE 3 · Dasar aksesibilitas (checklist WCAG 2.1 AA design system) — */\n\n  /* Indikator fokus terlihat. Komponen NextUI memakai ring-nya sendiri (warnanya\n     sudah diarahkan ke --b-500 lewat token `focus`); aturan di layer base ini\n     hanya berlaku untuk elemen HTML biasa, karena utility NextUI menang layer. */\n  :focus-visible {\n    outline: 3px solid var(--b-500);\n    outline-offset: 2px;\n    border-radius: var(--r-xs);\n  }\n\n  /* CSS komponen (display:flex/grid) mengalahkan aturan UA untuk atribut hidden.\n     Tanpa penegasan ini, panel yang \"disembunyikan\" tetap tampil. */\n  [hidden] {\n    display: none !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n@layer components {\n  /* — Tautan lewati ke konten utama (wajib per checklist DS) — */\n  .skip {\n    position: absolute;\n    left: -9999px;\n    top: 0;\n    z-index: 100;\n    display: inline-flex;\n    align-items: center;\n    min-height: 44px; /* checklist DS: target sentuh minimum */\n    background: var(--g-600);\n    color: #fff;\n    padding: 10px 16px;\n    border-radius: 0 0 8px 0;\n    font-weight: 600;\n    font-size: var(--t-sm);\n  }\n  .skip:focus {\n    left: 0;\n  }\n\n  /* — Skala tipe design system, dipakai secara sengaja oleh komponen — */\n  .t-display {\n    font-family: var(--font-display);\n    font-size: var(--t-display);\n    font-weight: 800;\n    line-height: var(--lh-tight);\n    letter-spacing: -0.02em;\n  }\n  .t-h1 { font-family: var(--font-display); font-size: var(--t-h1); font-weight: 700; line-height: var(--lh-tight); }\n  .t-h2 { font-family: var(--font-display); font-size: var(--t-h2); font-weight: 700; line-height: var(--lh-snug); }\n  .t-h3 { font-family: var(--font-display); font-size: var(--t-h3); font-weight: 700; line-height: var(--lh-snug); }\n  .t-h4 { font-family: var(--font-display); font-size: var(--t-h4); font-weight: 700; line-height: var(--lh-snug); }\n  .t-body { font-size: var(--t-body); line-height: var(--lh-body); }\n  .t-sm { font-size: var(--t-sm); }\n  .t-xs { font-size: var(--t-xs); }\n  .t-mono { font-family: var(--font-mono); }\n\n  /* Panjang baris ideal prosa 60–75ch (DS §03 Tipografi) */\n  .t-prose { max-width: 70ch; }\n\n  /* — FASE 6 · Tabel data (spesifikasi .tbl design system) —\n\n     NextUI Table dipakai di 47 berkas, jadi header-nya diseragamkan lewat\n     selektor peran alih-alih menyunting tiap pemanggilan. Hanya <th> milik\n     react-aria yang cocok dengan selektor ini; MUI DataGrid memakai\n     div[role=\"columnheader\"] sehingga tidak ikut terkena — DataGrid diatur\n     lewat tema MUI. !important diperlukan karena NextUI menempelkan utility\n     bg-default-100 langsung pada elemen th-nya. */\n  th[role=\"columnheader\"] {\n    background-color: var(--g-700) !important;\n    color: #ffffff !important;\n    font-size: 12px !important;\n    font-weight: 600 !important;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    white-space: nowrap;\n  }\n\n  /* Perbaikan overflow horizontal pada 390px (checklist QA design system).\n     NextUI membungkus tablist dengan wadah inline-flex tanpa batas lebar,\n     sehingga baris tab yang panjang melebarkan seluruh halaman: terukur\n     scrollWidth 451px pada viewport 390px, dengan wadah tab selebar 429px.\n     tabList-nya sendiri sudah overflow-x-scroll, jadi cukup wadahnya yang\n     dibatasi; setelah itu scrollWidth turun menjadi 375px. Ini juga yang\n     membuat Highcharts mengunci lebar kontainernya pada lebar yang sudah\n     terlanjur melebar. */\n  [data-slot=\"base\"]:has(> [data-slot=\"tabList\"]) {\n    max-width: 100%;\n  }\n\n  /* ====== Target sentuh 44px (checklist layout design system) ======\n     DS mewajibkan kontrol interaktif minimal 44x44px. NextUI memakai h-10\n     (40px) untuk ukuran md dan h-8 (32px) untuk sm. Aplikasi ini didominasi\n     sm — 183 pemakaian eksplisit, dan seluruh halaman daftar admin memakainya,\n     termasuk 64 tombol ikon aksi di dalam baris tabel.\n\n     min-height mengalahkan height, jadi tinggi dinaikkan lewat satu aturan\n     tanpa menyentuh 509 pemanggilan <Button> satu per satu.\n\n     Pengecualian DS — boleh di bawah 44px bila jarak antar-target >= 24px DAN\n     ada alternatif setara yang lebih besar — tidak berlaku di sini: tombol\n     edit dan hapus hanya berjarak ~8px dan tidak ada alternatif lain untuk\n     aksi tersebut.\n\n     Biaya yang disadari dan diterima: tinggi baris tabel bertambah ~10px. */\n  button.h-10,\n  button.h-8 {\n    min-height: 44px;\n  }\n  button.h-10.w-10,\n  button.h-8.w-8 {\n    min-width: 44px; /* tombol ikon tetap persegi */\n  }\n\n  /* Item paginasi NextUI memakai <li>/<span>, bukan <button>, sehingga tidak\n     tersentuh aturan tombol di atas; ukurannya h-9 (36px). Cakupan dibatasi\n     pada <nav> milik Pagination lewat atribut data-total — penanda yang khas\n     dan tidak bergantung bahasa, tidak seperti aria-label yang ikut locale.\n     Halaman yang sama memuat tiga elemen data-slot=\"item\" lain yang bukan\n     paginasi, dan aturan ini sengaja tidak mengenainya.\n     Wadah nav-nya sudah overflow-x-scroll, jadi pelebaran tidak memicu\n     overflow halaman. */\n  nav[data-slot=\"base\"][data-total] [data-slot=\"item\"],\n  nav[data-slot=\"base\"][data-total] [data-slot=\"prev\"],\n  nav[data-slot=\"base\"][data-total] [data-slot=\"next\"],\n  nav[data-slot=\"base\"][data-total] [data-slot=\"cursor\"] {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* Kolom angka — padanan .tbl .num milik DS. Dipasang manual per kolom;\n     pada DataGrid, kolom bertipe number sudah otomatis lewat tema MUI. */\n  .tbl-num {\n    text-align: right;\n    font-family: var(--font-mono);\n  }\n\n  /* Pembungkus gulir tabel. DS: tabel menggulir di dalam wadahnya pada layar\n     sempit — dilarang menyembunyikan kolom kunci. */\n  .tbl-wrap {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  /* Kilau skeleton — spesifikasi .skel design system. Blok\n     prefers-reduced-motion di atas otomatis mematikan animasinya. */\n  .ds-skeleton {\n    position: relative;\n    overflow: hidden;\n  }\n  .ds-skeleton::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    transform: translateX(-100%);\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);\n    animation: ds-shimmer 1.4s infinite;\n  }\n}\n\n@keyframes ds-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.ql-container {\n  min-height: 200px;\n}\n\n.ql-editor {\n  min-height: 200px;\n}\n\n.sub-accord-item h2 button div span {\n  color: hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity))) !important;\n  --tw-text-opacity: 1 !important;\n  font-size: var(--nextui-font-size-small) !important;\n  line-height: var(--nextui-line-height-small) !important;\n}\n\n.title-paragraph-break {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  white-space: pre-wrap;\n}\n\n.content-paragraph-break {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  white-space: pre-wrap;\n}\n\n/* ==========================================================================\n   Sel DataGrid yang berisi tombol aksi\n\n   SENGAJA DI LUAR @layer. Tailwind memangkas aturan di dalam @layer components\n   bila nama kelas pada selektornya tidak pernah muncul di berkas sumber.\n   .MuiDataGrid-cell dibuat MUI saat runtime, tidak pernah ditulis di kode kita,\n   jadi aturan ini hilang dari CSS hasil build bila ditaruh di dalam layer -\n   persis yang terjadi pada percobaan pertama.\n\n   Alasan aturannya: sel DataGrid memakai display:block, sehingga isi sel yang\n   lebih pendek dari tinggi baris menempel ke atas - kelihatan pada tombol aksi\n   44px di dalam baris 52px. Cakupan dibatasi ke sel yang memang berisi tombol\n   memakai :has(); mengubah SEMUA sel menjadi flex akan mematahkan pemotongan\n   teks dengan elipsis yang diandalkan MUI pada sel teks biasa.\n   ========================================================================== */\n.MuiDataGrid-root .MuiDataGrid-cell:has(button) {\n  display: flex !important;\n  align-items: center;\n}\n\n/* Tombol di dalam sel dibuat ringkas 28px, sama dengan rilis produksi\n   rilis/ui-admin. Aturan 44px versi .klh di styles/publik-klh.css tidak\n   ber-layer, jadi pengecualian ini juga harus di luar layer. */\n.MuiDataGrid-root .MuiDataGrid-cell:has(button) > div {\n  align-items: center;\n}\n.MuiDataGrid-root .MuiDataGrid-cell button.h-10,\n.MuiDataGrid-root .MuiDataGrid-cell button.h-8 {\n  min-height: 0;\n  height: 28px;\n}\n.MuiDataGrid-root .MuiDataGrid-cell button.h-10.w-10,\n.MuiDataGrid-root .MuiDataGrid-cell button.h-8.w-8 {\n  min-width: 0;\n  width: 28px;\n  border-radius: var(--r-sm, 8px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
